<template>
  <div class="interview-container">
    <div class="interview-page">
      <!-- 主要内容区域 -->
      <div class="interview-content">
        <!-- 左侧对话区域 -->
        <div class="chat-sidebar" >
          <div class="panel-header" style="display: flex; justify-content: space-between; align-items: center;">
            <div class="tab-title">
              沟通记录{{ formattedTime }}
            </div>
          </div>
         
          <div class="chat-messages" :class="{ 'no-scroll': conversationList.length === 0 }" ref="messagesContainer">
            <div v-if="conversationList.length === 0" class="empty-conversation">
              <div class="empty-answer">
                <div style="text-align: left;">
                  • 此处显示会议实时沟通记录<br>
                  • 语音识别大模型存在错误概率，但只要整体表达准确，不影响答题效果
                  <br><br><br><br><br>
                  <br>
                  <br>
                </div>
              </div>
            </div>
            <div v-else v-for="(item, index) in conversationList" :key="index" class="message" :class="item.speaker === '你' ? 'candidate' : 'interviewer'">
              <div class="message-header">
                <div class="message-sender">{{ item.speaker }}</div>
                <div class="message-time">{{ item.timestamp }}</div>
              </div>
              <div class="message-text">{{ item.content }}</div>
              
              <button
                v-if="this.interviewInfo.status === 1"
                class="quick-answer-btn"
                style="margin-right: 8px;"
                @click="handleQuickAnswerClick(item, index, false)"
              >快答</button>
              <button
                v-if="this.interviewInfo.status === 1"
                class="quick-answer-btn"
                @click="handleQuickAnswerClick(item, index, true)"
              >深度回答</button>
            </div>
          </div>
          

        </div>
         <!-- 右侧回答区域 -->
        <div class="answer-area">
          <div class="answer-panels">
            <!-- 快答区域 -->
            <div v-show="showQuickContent" class="tab-panel" :style="{ flex: showQuickContent ? quickAnswerFlex : 1 }">
              <div class="panel-header" style="display: flex; justify-content: space-between; align-items: center;">
                <div class="tab-title">快答</div>
              </div>
              <div class="answer-input readonly-box answer-box-big">
                <div class="content-area" ref="quickAnswerContentRef" @dblclick="toggleDirection">
                  <div v-if="!quickAnswerContent" class="empty-answer">
                    <div style="text-align: left;">
                      • 此处显示通用大模型的快速回答结果<br>
                      • 高时效性题目建议联网，其余无需联网<br>
                      • 可通过以下方式调整布局：<br>
                      
                         &nbsp; &nbsp; &nbsp;①单击右侧工具栏&lt;布局调整&gt;按钮<br>
                         &nbsp; &nbsp; &nbsp;②双击空白区域<br>
                         &nbsp; &nbsp; &nbsp;③拖住中间边框调整
                    </div>
                  </div>
                  <div v-else v-html="parsedMarkdown"></div>
                </div>
         
              </div>
            </div>
             <!-- 快答区域隐藏时显示竖条 -->
            <!-- <div v-show="!showQuickContent" @click="showQuickContent = true" class="area-bar-vertical">快答区域</div> -->
            <!-- 深度区域隐藏时显示竖条 -->
            <!-- <div v-show="!showDeepContent" @click="showDeepContent = true" class="area-bar-vertical">深度区域</div> -->
            <!-- 竖条 -->
            <div v-show="showQuickContent && showDeepContent" class="divider">
              <div class="divider-line" @mousedown="startResize" @touchstart="startResize"></div>
            </div>
            <!-- 深度区域 -->
            <div v-show="showDeepContent" class="tab-panel" :style="{ flex: deepAnswerFlex }">
              <div class="panel-header" style="display: flex; justify-content: space-between; align-items: center;">
                <div class="tab-title">深度/截图</div>
              </div>
              <div class="answer-input readonly-box answer-box-big">
                <div class="content-area" @dblclick="toggleDirection">
                  <div v-if="!deepThinkReason && !deepThinkAnswer" class="empty-answer">
                    <div style="text-align: left;">
                      • 此处显示推理大模型的回答结果<br>
                      • 适用于编程和推理题目<br>
                      • 有一定时延
                    </div>
                  </div>
                  <!-- 思考过程区域 -->
                  <div v-if="deepThinkReason" class="thinking-section">
                    <div class="thinking-header" @click="toggleThinking">
                      <span class="thinking-title">
                        思考过程
                        <span v-if="isReasonThinking && !parsedMarkdownAnswer" class="thinking-status-inline">思考中...</span>
                      </span> 
                      <svg class="toggle-icon" :class="{ 'expanded': !isThinkingCollapsed }" viewBox="0 0 24 24" width="16" height="16">
                        <path d="M7 10l5 5 5-5z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div class="thinking-content" :class="{ 'collapsed': isThinkingCollapsed }" ref="deepReasonContainer">
                      <div v-html="parsedMarkdownReason"></div>
                      
                    </div>
                  </div>
                  
                  <!-- 最终答案区域 -->
                  <div v-if="deepThinkAnswer" class="answer-section">
                    <div class="answer-header">
                      <span class="answer-title">最终答案</span>
                    </div>
                    <div class="answer-content" ref="deepAnswerContainer">
                      <div v-html="parsedMarkdownAnswer"></div>
                    </div>
                  </div>
                </div>
                <!-- <button class="submit-btn big-btn inner-btn" @click="handleDeepThinkClick(null,true)" v-show="this.interviewInfo.status === 1">回答</button> -->
              </div>
            </div>
           
          </div>
          <div class="question-panel">
            <div class="panel-header" style="display: flex; justify-content: space-between; align-items: center;">
              <div class="tab-title">问题修正</div>
            </div>
            <div class="question-edit-wrapper">
              <textarea v-model="questionAnalysis" class="analysis-input editable full-width" rows="3" placeholder="如果识别不准确，请手动改正问题，务必点击文本框右侧按钮"></textarea>
              
              <div class="button-container">
                <button class="reanswer-btn vertical-btn" @click="handleQuickAnswerClick(null, false)" v-show="this.interviewInfo.status === 1">
                  <span class="btn-text">快答</span>
                 
                </button>
                <button class="reanswer-btn vertical-btn" @click="handleDeepThinkClick(null, true)" v-show="this.interviewInfo.status === 1">
                  <span class="btn-text">深度</span>
                  
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- 工具栏移到 interview-page 下，与 header、content 平级 -->
      <div class="toolbar" ref="toolbarRef">
        <!-- 第一区域：面试设置  快捷键设置   结束面试   -->
        <div class="toolbar-section">
          <div class="toolbar-item" @click="openInterviewSettings">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.03-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">面试<br>设置</span>
          </div>
          
           <div class="toolbar-item" @click="openShortcutSettings">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">快捷键<br>设置</span>
          </div> 
          <div class="toolbar-item" @click="handleEndInterview">
            <div class="tool-icon end-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">结束<br>面试</span>
          </div>
        </div>
        <!-- 第二区域：深色模式  联网  音频设置   布局调整 -->
        <div class="toolbar-section">
          <div class="toolbar-item" @click="toggleDarkMode">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z" fill="currentColor"/>
              </svg>
            </div>
            <span v-show="!isDarkMode" class="tool-label">深色<br>模式</span>
            <span v-show="isDarkMode" class="tool-label">浅色<br>模式</span>
          </div>
          <div class="toolbar-item" @click="toggleConnection">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">联网</span>
            <div class="toggle-switch" :class="{ 'is-checked': formData.onlineMode }">
              <div class="toggle-switch-handle"></div>
            </div>
          </div>
          <div class="toolbar-item" @click="handleConnectClient">
            <div class="tool-icon">
              <svg v-if="isWebsocketConnected" viewBox="0 0 24 24" width="20" height="20">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" fill="currentColor"/>
                <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" fill="currentColor"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" width="20" height="20">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" fill="#ff4d4f"/>
                <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" fill="#ff4d4f"/>
                <line x1="5" y1="5" x2="19" y2="19" stroke="#ff4d4f" stroke-width="2"/>
              </svg>
            </div>
            <span class="tool-label">音频<br>链接</span>
          </div>
          <div class="toolbar-item" @click="toggleDirection">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">布局<br>调整</span>
          </div>
        </div>
        <!-- 第三区域：停止回答  截图回答  深度回答  快答 -->
        <div class="toolbar-section">
          <div class="toolbar-item" @click="stopAnswer">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M6 6h12v12H6z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">停止<br>回答</span>
          </div>
          <div class="toolbar-item" @click="handleScreenshotAnswer">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">截图<br>回答</span>
          </div>
          <div class="toolbar-item" @click="deepAnswerAction">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">深度<br>回答</span>
          </div>
          <div class="toolbar-item" @click="quickAnswerAction">
            <div class="tool-icon">
              <svg viewBox="0 0 24 24" width="20" height="20">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
              </svg>
            </div>
            <span class="tool-label">快答</span>
          </div>
        </div>
      </div>
      <InterviewSetting
        ref="interviewSetting"
        :visible="dialogSettingVisible"
        :currentTab="currentTab"
        :settingName="settingName"
        v-if="dialogSettingVisible"
        :interviewId="interviewInfo.interviewId"
        @close="dialogSettingVisible = false"
      />

      <!-- IP地址输入弹窗 -->
      <el-dialog
        title="配置客户端连接"
        width="500px"
        v-model="showIpInputDialog"
        :close-on-click-modal="false"
        append-to-body
      >
        <el-form :model="ipInputForm" label-width="80px">
          <el-form-item label="IP地址">
            <el-input 
              v-model="ipInputForm.ip" 
              placeholder="请输入客户端IP地址，如：192.168.1.100"
              clearable
              @keyup.enter="handleConfirmIpBinding"
            ></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="showIpInputDialog = false">取消</el-button>
            <el-button type="primary" @click="handleConfirmIpBinding" :disabled="!ipInputForm.ip">确定</el-button>
          </span>
        </template>
      </el-dialog>

      
    </div>
    
    
  </div>
  
  
</template>

<script>
import { marked } from "marked";
import InterviewSetting from "./InterviewSetting.vue";
import { interviewInfo, interviewEnd, recordUsage } from "@/api/interview";
import { isMacOS } from "@/utils/common";
import { getUserInfo } from "@/api/login/login";
import { useStore } from "@/store";

export default {
  components: {
    InterviewSetting,
  },
  data() {
    return {
      heartbeatInterval: null, // 心跳定时器
      authInterval: null,      // 认证定时器
      lastPongTime: null,      // 上次收到消息时间
      missedHeartbeats: 0,     // 连续未收到心跳的次数
      heartbeatRetryCount: 0,  // 心跳重试次数
      isPageVisible: true,     // 页面是否可见
      shortcutKey: "",//截图快捷键
      startTime: "",//面试开始时间
      balance: 0,//用户余额
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null, // 用于存储定时器 ID
      interviewInfo: {
        status: "", // 面试状态
      },
      formData: {
        onlineMode: false, // 是否联网,
        needDeepThink: false, // 是否需要深度思考
        questionNow: "", // 当前问题
        contentInfoList: [],// 快答对话信息列表
      },
      questionAnalysis: "", //问题分析
      quickAnswerContent:
        "", // 新增：用于存储快答返回的内容
      deepThinkContent:
        "", // 用于显示深度思考的内容
      deepThinkReason: "", // 思考过程内容
      deepThinkAnswer: "", // 最终答案内容
      isThinkingCollapsed: false, // 思考过程是否收起
      quickAnswerFlex: 6,
      deepAnswerFlex: 1,
      // 拖拽相关变量
      isResizing: false,
      startX: 0,
      startQuickFlex: 0,
      startDeepFlex: 0,
      // 面试设置弹窗标识
      dialogSettingVisible: false,
      currentTab: "basic",
      settingName: "",
      answeredCount: 0, // 已回答次数
      remainingAnswerCount: 3, // 预计剩余回答次数
      // 新增：用于取消请求的控制器
      currentAbortController: null,
      currentAbortController3: null,
      // 新增：请求状态标识
      isQuickAnswerRequesting: false,
      isDeepThinkRequesting: false,
      // 截图处理状态标识
      isScreenshotProcessing: false, // 防止截图多次弹窗
      shortcutListener: null, // 快捷键监听器引用
      isShortcutSetup: false, // 防止重复设置快捷键监听器
      conversationList: [], // 对话列表
      // 新增：防止重复添加快捷键监听器的标志
      isShortcutListenerAdded: false,
      // 对话列表相关
      isConversationEmpty: true, // 对话列表是否为空
      // WebSocket连接状态
      isWebsocketConnected: false, // WebSocket连接状态
      micWebsocket: null, // WebSocket实例
      reconnectAttempts: 0, // 重连尝试次数
      maxReconnectAttempts: 3, // 最大重连次数
      reconnectTimer: null, // 重连定时器
      allowReconnect: true, // 是否允许重连
      isUserInitiatedConnection: false, // 是否是用户主动发起的连接
      // 客户端绑定
      boundClientId: '', // 绑定的客户端ID（IP地址）
      showIpInputDialog: false, // 是否显示IP输入弹窗
      ipInputForm: {
        ip: '' // 用户输入的IP地址
      },
      clientList: [], // 可用的客户端列表
      isClientListLoaded: false, // 客户端列表是否已加载
      isReasonThinking: false, // 思考过程是否正在输出
      isDarkMode: true, // 默认深色模式，会在 created() 中根据 localStorage 调整
      websocketTimer: null, // WebSocket计时定时器
      websocketSeconds: 0, // WebSocket累计秒数
      globalShortcutListener: null, // 全局快捷键监听器
      showQuickContent: true,
      showDeepContent: true,
      // 音频监控相关
      micVolumeLevel: 0, // 麦克风音量级别 (0-100)
      speakerVolumeLevel: 0, // 扬声器音量级别 (0-100)
      micVolumeTimer: null, // 麦克风音量衰减定时器
      speakerVolumeTimer: null, // 扬声器音量衰减定时器
      resizeHandler: null,
      orientationHandler: null,
      visibilityChangeHandler: null, // 页面可见性监听器
      isInterviewEnded: false, // 面试是否已结束
      isPeriodicAuth: false, // 是否是定期重新认证触发的
      processedMessages: new Set(), // 已处理的消息ID集合，用于去重
      websocketUsageFailCount: 0,  // WebSocket扣费连续失败次数
      maxUsageFailAttempts: 3,      // 最大失败次数，连续3次失败才断开
    };
  },
  created() {
    this.store = useStore();
    this.getInterviewInfo(this.$route.query.interviewId);
    this.getUserInfo();
    // 恢复WebSocket计时缓存
    const interviewId = this.$route.query.interviewId;

    if (interviewId) {
      const wsTime = this.store.getWebsocketTimeByInterviewId && this.store.getWebsocketTimeByInterviewId(interviewId);
      if (typeof wsTime === 'number') {
        this.websocketSeconds = wsTime;
      }
    }
    // 从缓存中加载对话列表
    this.loadConversationFromStore();
    // 从本地存储恢复绑定的客户端IP
    this.loadBoundClientFromCache();
    // 客户端列表将通过WebSocket消息自动获取
    // 加载答题内容缓存
    this.loadAnswerCache();
    // 深色模式持久化（默认深色模式）
    const dark = localStorage.getItem('isDarkMode');
    if (dark === '0') {
      // 用户明确选择了浅色模式
      this.isDarkMode = false;
      document.body.classList.remove('dark-mode');
      this.$nextTick(() => {
        this.clearDarkTableFix();
      });
    } else {
      // 默认深色模式（包括 localStorage 中没有值或值为 '1'）
      this.isDarkMode = true;
      document.body.classList.add('dark-mode');
      // 初始化时设置竖条的深色模式样式
      this.$nextTick(() => {
        const areaBars = document.querySelectorAll('.area-bar-vertical');
        areaBars.forEach(bar => {
          bar.style.background = '#6a707b';
          bar.style.borderLeftColor = '#333';
          bar.style.borderRightColor = '#333';
        });

        // 初始化时设置思考过程和答案区域的深色模式样式
        const thinkingSections = document.querySelectorAll('.thinking-section');
        thinkingSections.forEach(section => {
          section.style.background = '#6a707b';
        });

        const answerSections = document.querySelectorAll('.answer-section');
        answerSections.forEach(section => {
          section.style.background = '#6a707b';
        });

        const thinkingHeaders = document.querySelectorAll('.thinking-header');
        thinkingHeaders.forEach(header => {
          header.style.background = '#6a707b';
        });

        const answerHeaders = document.querySelectorAll('.answer-header');
        answerHeaders.forEach(header => {
          header.style.background = '#6a707b';
        });

        // 确保按钮在深色模式下保持蓝色背景
        const reanswerBtns = document.querySelectorAll('.reanswer-btn');
        reanswerBtns.forEach(btn => {
          btn.style.background = '#1890ff !important';
          btn.style.color = '#fff !important';
          btn.style.borderColor = '#1890ff !important';
          btn.setAttribute('style', btn.getAttribute('style') + '; background: #1890ff !important; color: #fff !important; border-color: #1890ff !important;');
        });
        // 新增：初始化后对表格执行暗色修正
        this.applyDarkTableFix();
      });
    }
  },
  computed: {
    parsedMarkdown() {
      console.log(this.quickAnswerContent)
      return marked(this.quickAnswerContent);
    },
    parsedMarkdownDeep() {
      return marked(this.deepThinkContent);
    },
    parsedMarkdownReason() {
      return marked(this.deepThinkReason);
    },
    parsedMarkdownAnswer() {
      return marked(this.deepThinkAnswer);
    },
    //
    formattedTime() {
      const padZero = (num) => String(num).padStart(2, "0");
      return `${padZero(this.hours)}:${padZero(this.minutes)}:${padZero(
        this.seconds
      )}`;
    },
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  methods: {
    applyDarkTableFix() {
      try {
        if (!this.isDarkMode) return;
        const roots = [];
        if (this.$refs && this.$refs.quickAnswerContentRef) roots.push(this.$refs.quickAnswerContentRef);
        if (this.$refs && this.$refs.deepReasonContainer) roots.push(this.$refs.deepReasonContainer);
        if (this.$refs && this.$refs.deepAnswerContainer) roots.push(this.$refs.deepAnswerContainer);
        const selectors = ['table', 'thead', 'tbody', 'tr', 'th', 'td'];
        roots.forEach(root => {
          if (!root) return;
          selectors.forEach(sel => {
            root.querySelectorAll(sel).forEach(el => {
              try {
                el.style.setProperty('background', '#000', 'important');
                el.style.setProperty('color', '#fff', 'important');
                if (sel === 'th' || sel === 'td') {
                  el.style.setProperty('border-color', '#444', 'important');
                  el.style.setProperty('border-width', '1px', 'important');
                  el.style.setProperty('border-style', 'solid', 'important');
                }
              } catch (e) { /* ignore single node errors */ }
            });
          });
          // 同时清掉可能被写在 tr/td 上的背景图片等
          root.querySelectorAll('tr, th, td').forEach(el => {
            try {
              el.style.removeProperty('background-image');
            } catch (e) { console.debug('remove bg image failed', e); }
          });
        });
      } catch (e) {
        console.warn('applyDarkTableFix error', e);
      }
    },
    clearDarkTableFix() {
      try {
        const roots = [];
        if (this.$refs && this.$refs.quickAnswerContentRef) roots.push(this.$refs.quickAnswerContentRef);
        if (this.$refs && this.$refs.deepReasonContainer) roots.push(this.$refs.deepReasonContainer);
        if (this.$refs && this.$refs.deepAnswerContainer) roots.push(this.$refs.deepAnswerContainer);
        const selectors = ['table', 'thead', 'tbody', 'tr', 'th', 'td'];
        roots.forEach(root => {
          if (!root) return;
          selectors.forEach(sel => {
            root.querySelectorAll(sel).forEach(el => {
              try {
                el.style.removeProperty('background');
                el.style.removeProperty('color');
                if (sel === 'th' || sel === 'td') {
                  el.style.removeProperty('border-color');
                  el.style.removeProperty('border-width');
                  el.style.removeProperty('border-style');
                }
              } catch (e) { /* ignore single node errors */ }
            });
          });
        });
      } catch (e) {
        console.warn('clearDarkTableFix error', e);
      }
    },
    startHeartbeat(ws) {
      this.stopHeartbeat();
      this.lastPongTime = Date.now();
      this.missedHeartbeats = 0;
      this.heartbeatRetryCount = 0;
      this.isPeriodicAuth = false;
      
      const HEARTBEAT_INTERVAL = 15000; // 心跳间隔 15秒
      const MAX_MISSED_HEARTBEATS = 4; // 最多允许连续丢失4次心跳（4 * 15秒 = 60秒）
      const HEARTBEAT_TIMEOUT = 60000; // 心跳超时时间 60秒
      const AUTH_INTERVAL = 30000; // 认证间隔 30秒
      
      this.heartbeatInterval = setInterval(() => {
        // 检查连接状态
        if (ws.readyState !== WebSocket.OPEN) {
          console.warn('WebSocket 未处于OPEN状态，停止心跳');
          this.stopHeartbeat();
          return;
        }

        // 如果页面不可见，降低心跳频率（跳过本次心跳）
        if (!this.isPageVisible && this.missedHeartbeats < 2) {
          return;
        }

        const timeSinceLastPong = Date.now() - this.lastPongTime;
        
        // 检查是否超时
        if (timeSinceLastPong > HEARTBEAT_TIMEOUT) {
          this.missedHeartbeats++;
          console.warn(`心跳超时 (${this.missedHeartbeats}/${MAX_MISSED_HEARTBEATS}): ${timeSinceLastPong}ms`);
          
          if (this.missedHeartbeats >= MAX_MISSED_HEARTBEATS) {
            console.error(`连续丢失${this.missedHeartbeats}次心跳，判定连接断开`);
            this.isWebsocketConnected = false;
            this.$message({
              message: '连接超时，心跳检测失败',
              type: 'error',
              duration: 3000,
            });
            // 在心跳判定断开前尝试通知客户端停止ASR
            try {
              if (ws && ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify({
                  type: 'to-client-by-ip',
                  ip: this.boundClientId,
                  data: { action: 'stop-asr' }
                }));
                console.log(`心跳超时：断开前已发送停止ASR指令到 ${this.boundClientId}`);
              }
            } catch (e) {
              console.error('心跳超时：发送停止ASR指令失败', e);
            }
            ws.close();
            this.stopHeartbeat();
            return;
          }
        } else {
          // 心跳正常，重置计数器
          if (this.missedHeartbeats > 0) {
            this.missedHeartbeats = 0;
          }
        }

        // 发送增强的心跳消息
        try {
          const heartbeatMessage = {
            type: 'heartbeat',
            boundClientId: this.boundClientId,
            timestamp: Date.now(),
            isClientListLoaded: this.isClientListLoaded
          };
          ws.send(JSON.stringify(heartbeatMessage));
          console.log('发送心跳消息:', heartbeatMessage);
        } catch (error) {
          console.error('发送心跳失败:', error);
          this.missedHeartbeats++;
        }
      }, HEARTBEAT_INTERVAL);
      
      // 设置定期重新认证
      this.authInterval = setInterval(() => {
        if (ws.readyState === WebSocket.OPEN) {
          console.log('定期重新认证');
          this.isPeriodicAuth = true; // 标记为定期重新认证
          ws.send(JSON.stringify({
            type: 'auth',
            role: 'web',
            ip: this.boundClientId,
            token: 'web_token_placeholder'
          }));
          // 注意：不要在这里立即检查IP，因为认证响应和客户端列表更新是异步的
          // IP检查应该在收到认证响应和客户端列表更新后进行
        }
      }, AUTH_INTERVAL);
      
    },
    stopHeartbeat() {
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
        this.missedHeartbeats = 0;
        this.heartbeatRetryCount = 0;
      }
      
      // 清除认证定时器
      if (this.authInterval) {
        clearInterval(this.authInterval);
        this.authInterval = null;
      }

      this.isPeriodicAuth = false;
    },
    handleConnectClient() {
      if (this.isWebsocketConnected) {
        // 如果已连接，则断开连接
        this.allowReconnect = false; // 不允许自动重连
        this.connectWebsockets(false);
        this.$message({
          message: '已断开连接',
          type: 'info',
          duration: 2000,
        });
      } else {
        // 如果未连接，尝试连接
        this.allowReconnect = true; // 允许重连
        this.isUserInitiatedConnection = true; // 标记为用户主动连接
        this.isClientListLoaded = false;
        this.clientList = [];
        this.connectWebsockets(true);
      }
    },

    handleDisConnectClient() {
      if (this.isWebsocketConnected) {
        // 如果已连接，则断开连接
        this.allowReconnect = false; // 不允许自动重连
        this.connectWebsockets(false);
        this.$message({
          message: '远端音频异常断开，请重新连接',
          type: 'info',
          duration: 5000,
        });
      }
    },

    // 确认IP绑定
    handleConfirmIpBinding() {
      const ip = this.ipInputForm.ip.trim();

      if (!ip) {
        this.$message({
          message: '请输入IP地址',
          type: 'warning',
          duration: 2000,
        });
        return;
      }

      // 验证IP格式
      const ipRegex = /^(localhost|(\d{1,3}\.){3}\d{1,3})$/;
      if (!ipRegex.test(ip)) {
        this.$message({
          message: '请输入正确的IP地址格式',
          type: 'warning',
          duration: 2000,
        });
        return;
      }

      // 设置绑定的客户端ID
      this.boundClientId = ip;
      this.showIpInputDialog = false;

      // 保存绑定到本地存储（包含时间戳）
      this.saveBoundClientToCache(this.boundClientId);

      // 自动建立WebSocket连接
      this.allowReconnect = true; // 允许重连
      this.isUserInitiatedConnection = true; // 标记为用户主动连接
      this.isClientListLoaded = false;
      this.clientList = [];
      this.connectWebsockets(true);

    },
    // 截图回答接口 - 只调用深度思考
    async handleShortcutAnswer(val) {
      // 检查面试状态
      if (this.interviewInfo.status === 2) {
        this.$message({
          message: '面试已结束',
          type: 'error',
          duration: 1500,
        })
        return;
      }

      // 终止之前的深度思考请求
      if (this.isDeepThinkRequesting && this.currentAbortController3) {
        this.currentAbortController3.abort();
        // 等待一小段时间确保请求被完全终止
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // 创建新的深度思考 AbortController
      this.currentAbortController3 = new AbortController();
      this.isDeepThinkRequesting = true;
      this.deepThinkContent = ""; // 清空深度思考内容
      this.deepThinkReason = ""; // 清空思考过程内容
      this.deepThinkAnswer = ""; // 清空答案内容

      // 设置问题分析
      this.questionAnalysis = "截图内容分析";
      this.store.questionNow = "截图内容分析";

      // 添加用户消息到对话列表
      const contentInfo = {
        role: 'user',
        content: '截图内容分析'
      };
      const contentInfoList = [];
      contentInfoList.push(contentInfo);

      const obj = {
        imageBase64: val,
        interviewLanguage: "",
        onlineMode: this.formData.onlineMode,
        needDeepThink: true, // 固定使用深度思考
        contentInfoList: contentInfoList,
      };

      const interviewId = this.$route.query.interviewId;
      const url = `/api/interview/${interviewId}/screenshot`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.store.token,
          },
          body: JSON.stringify(obj),
          signal: this.currentAbortController3.signal,
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8', { fatal: false, ignoreBOM: true });
        
        // 使用缓冲区来累积不完整的数据块，确保严格按顺序处理
        let buffer = '';
        let reasonCombined = '';
        let answerCombined = '';
        
        const appendDeepThinkSegments = (reasonSegment, answerSegment) => {
          const hasReason = typeof reasonSegment === 'string';
          const hasAnswer = typeof answerSegment === 'string';
          if (!hasReason && !hasAnswer) {
            return;
          }
          if (hasReason) {
            reasonCombined += reasonSegment;
          }
          if (hasAnswer) {
            answerCombined += answerSegment;
          }
          this.deepThinkReason = reasonCombined;
          this.deepThinkAnswer = answerCombined;
          this.deepThinkContent = reasonCombined + answerCombined;
        };
        
        let done = false;
        while (!done) {
          const result = await reader.read();
          done = result.done;
          
          if (result.value) {
            // 将新读取的数据追加到缓冲区
            // 如果流已结束，使用最终解码；否则使用流式解码
            buffer += decoder.decode(result.value, { stream: !done });
          } else if (done) {
            // 流结束时，进行最终解码以处理任何剩余字节
            buffer += decoder.decode();
          }
          
          // 按照 \n\n 分割完整的事件消息（SSE 格式）
          // 最后一个不完整的块保留在 buffer 中，等待下一次读取
          const parts = buffer.split('\n\n');
          
          // 保留最后一个可能不完整的块在 buffer 中
          buffer = parts.pop() || '';
          
          // 严格按顺序处理每个完整的消息块
          for (let i = 0; i < parts.length; i++) {
            const chunk = parts[i].trim();
            if (!chunk) continue;
            
            // 解析 SSE 格式：event: message\ndata: {...}
            const lines = chunk.split('\n');
            let eventLine = '';
            const dataLines = []; // 支持多行 data（SSE 规范允许多个 data: 行）
            
            // 按顺序查找 event 和所有 data 行
            for (const line of lines) {
              const trimmedLine = line.trim();
              if (trimmedLine.startsWith('event:')) {
                eventLine = trimmedLine;
              } else if (trimmedLine.startsWith('data:')) {
                // 收集所有 data 行（SSE 规范中多个 data 行需要拼接）
                dataLines.push(trimmedLine);
              }
            }
            
            // 只处理 event:message 的消息
            if (eventLine === 'event:message' && dataLines.length > 0) {
              // 拼接所有 data 行（SSE 规范：多个 data: 行用换行符拼接）
              let cleanDataLine = dataLines.map(line => {
                // 去除每行的 data: 前缀
                let cleaned = line.replace(/^data:\s*/, '');
                // 处理可能的重复前缀
                while (cleaned.startsWith('data:')) {
                  cleaned = cleaned.replace(/^data:\s*/, '');
                }
                return cleaned;
              }).join('\n'); // SSE 规范：多个 data 行用换行符拼接
              
              try {
                const data = JSON.parse(cleanDataLine);
                
                // 严格按照返回顺序累加内容，确保不丢失任何数据
                const reasonContent = data.reason_content || '';
                const answerContent = data.answer_content || '';
                
                appendDeepThinkSegments(reasonContent, answerContent);
              } catch (e) {
                // JSON 解析失败时，尝试从不完整 JSON 中提取内容，确保不丢失数据
                console.warn('解析流式数据失败:', e, '原始数据:', cleanDataLine);
                
                // 尝试使用正则表达式提取 JSON 字段值，即使 JSON 不完整也能提取部分内容
                let reasonContent = '';
                let answerContent = '';
                
                // 尝试提取 reason_content 字段值（支持转义字符）
                const reasonMatch = cleanDataLine.match(/"reason_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (reasonMatch && reasonMatch[1]) {
                  reasonContent = reasonMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                // 尝试提取 answer_content 字段值（支持转义字符）
                const answerMatch = cleanDataLine.match(/"answer_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (answerMatch && answerMatch[1]) {
                  answerContent = answerMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                appendDeepThinkSegments(reasonContent, answerContent);
              }
            }
          }
          
          // 如果流已经结束，处理剩余的 buffer
          if (done && buffer.trim()) {
            // 流结束时尝试处理最后一个可能不完整的块
            const lines = buffer.split('\n');
            let eventLine = '';
            const dataLines = []; // 支持多行 data（SSE 规范允许多个 data: 行）
            
            for (const line of lines) {
              const trimmedLine = line.trim();
              if (trimmedLine.startsWith('event:')) {
                eventLine = trimmedLine;
              } else if (trimmedLine.startsWith('data:')) {
                // 收集所有 data 行（SSE 规范中多个 data 行需要拼接）
                dataLines.push(trimmedLine);
              }
            }
            
            if (eventLine === 'event:message' && dataLines.length > 0) {
              // 拼接所有 data 行（SSE 规范：多个 data: 行用换行符拼接）
              let cleanDataLine = dataLines.map(line => {
                // 去除每行的 data: 前缀
                let cleaned = line.replace(/^data:\s*/, '');
                // 处理可能的重复前缀
                while (cleaned.startsWith('data:')) {
                  cleaned = cleaned.replace(/^data:\s*/, '');
                }
                return cleaned;
              }).join('\n'); // SSE 规范：多个 data 行用换行符拼接
              
              try {
                const data = JSON.parse(cleanDataLine);
                const reasonContent = data.reason_content || '';
                const answerContent = data.answer_content || '';
                
                appendDeepThinkSegments(reasonContent, answerContent);
              } catch (e) {
                // JSON 解析失败时，尝试从不完整 JSON 中提取内容，确保不丢失数据
                console.warn('解析流式数据（最后一块）失败:', e, '原始数据:', cleanDataLine);
                
                // 尝试使用正则表达式提取 JSON 字段值，即使 JSON 不完整也能提取部分内容
                let reasonContent = '';
                let answerContent = '';
                
                // 尝试提取 reason_content 字段值（支持转义字符）
                const reasonMatch = cleanDataLine.match(/"reason_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (reasonMatch && reasonMatch[1]) {
                  reasonContent = reasonMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                // 尝试提取 answer_content 字段值（支持转义字符）
                const answerMatch = cleanDataLine.match(/"answer_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (answerMatch && answerMatch[1]) {
                  answerContent = answerMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                appendDeepThinkSegments(reasonContent, answerContent);
              }
            }
            buffer = '';
          }
        }

        // 存储问答记录（截图回答）
        if (this.questionAnalysis && this.deepThinkAnswer) {
          const interviewId = this.$route.query.interviewId;
          this.store.addAnswerRecordByInterviewId(interviewId, this.questionAnalysis, undefined, undefined, this.deepThinkAnswer);
        }

      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }
        console.error("截图深度思考请求失败:", error);
      } finally {
        this.currentAbortController3 = null;
        this.isDeepThinkRequesting = false;
        this.isReasonThinking = false;
      }
    },

    // 处理截图作答按钮点击（废弃）
    async handleScreenshotAnswerDeprecated() {
      this.micWebsocket.send(JSON.stringify({
        type: 'to-client-by-ip',
        ip: this.boundClientId,
        data: {
          action: 'start-asr',
          params: { key: '123456' }
        }
      }));
      console.log(`已发送启动ASR指令到客户端 IP ${this.boundClientId}`);


      // 立即检查并设置状态，防止重复调用
      if (this.isScreenshotProcessing) {

        return;
      }

      // 立即设置状态，防止在异步操作期间被重复调用
      this.isScreenshotProcessing = true;


      try {
        // 检查浏览器是否支持截图API
        if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
          this.$message.error('您的浏览器不支持屏幕截图功能，请使用Chrome、Firefox或Edge浏览器');
          return;
        }

        // 检查面试状态
        if (this.interviewInfo.status === 2) {
          this.$message.error('面试已结束，无法进行截图作答');
          return;
        }

        // 显示提示信息
        this.$message.info('请选择要截图的窗口，选择后会自动回到当前页面');

        // 获取屏幕媒体流
        const stream = await navigator.mediaDevices.getDisplayMedia({
          video: {
            mediaSource: 'window', // 指定为窗口模式，优先显示窗口选项
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          }
        });

        // 创建视频元素来捕获画面
        const video = document.createElement('video');
        video.srcObject = stream;

        // 等待视频加载完成
        await new Promise((resolve) => {
          video.onloadedmetadata = () => {
            video.play();
            resolve();
          };
        });

        // 创建canvas来绘制截图
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置canvas尺寸为视频尺寸
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // 在canvas上绘制视频帧
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // 立即停止所有媒体轨道，减少跳转时间
        stream.getTracks().forEach(track => {
          track.stop();
        });

        // 将canvas转换为base64编码
        const base64Image = canvas.toDataURL('image/png');

        // 尝试立即回到当前页面焦点
        try {
          window.focus();
          document.activeElement && document.activeElement.blur();
        } catch (e) {
          return;
        }


        // 调用截图回答方法
        const base64Imageval = base64Image.replace(/^data:image\/\w+;base64,/, "");
        this.handleShortcutAnswer(base64Imageval);

        this.$message.success('截图成功！正在分析图片内容...');

      } catch (error) {
        console.error('截图失败:', error);
        if (error.name === 'NotAllowedError') {
          this.$message.error('用户取消了截图操作');
        } else {
          this.$message.error('截图失败，请重试');
        }
      } finally {
        // 延迟重置状态，确保不会立即重复调用
        setTimeout(() => {
          this.isScreenshotProcessing = false;

        }, 1000);
      }
    },

    // 处理截图作答按钮点击
    async handleScreenshotAnswer() {
      this.micWebsocket.send(JSON.stringify({
        type: 'to-client-by-ip',
        ip: this.boundClientId,
        data: {
          action: 'start-screenshot',
        }
      }));
      console.log(`已发送截图指令到客户端 IP ${this.boundClientId}`);
    },
    // 发送启动ASR指令
    // 处理客户端截图作答按钮点击
    async handleClientScreenshotAnswer(base64Image) {
      // 立即检查并设置状态，防止重复调用
      if (this.isScreenshotProcessing) {

        return;
      }
      // 立即设置状态，防止在异步操作期间被重复调用
      this.isScreenshotProcessing = true;
      try {
        
        // 调用截图回答方法
        const base64Imageval = base64Image.replace(/^data:image\/\w+;base64,/, "");
        this.handleShortcutAnswer(base64Imageval);

        this.$message.success('截图成功！正在分析图片内容...');

      } catch (error) {
        console.error('截图失败:', error);
        if (error.name === 'NotAllowedError') {
          this.$message.error('用户取消了截图操作');
        } else {
          this.$message.error('截图失败，请重试');
        }
      } finally {
        // 延迟重置状态，确保不会立即重复调用
        setTimeout(() => {
          this.isScreenshotProcessing = false;

        }, 1000);
      }
    },


    //连接云端WSS服务器
    connectWebsockets(connect) {
      try {
        if (connect) {
          // 检查是否允许重连
          if (!this.allowReconnect) {
            console.log('重连已被禁止，取消连接');
            return;
          }
          
          const wsUrl = `wss:/www.linkoffer.cn/ws`;
          this.micWebsocket = new WebSocket(wsUrl);
          this.setupWebsocketLifecycle(this.micWebsocket, '云端');

          // 设置连接超时
          setTimeout(() => {
            if (this.micWebsocket && this.micWebsocket.readyState === WebSocket.CONNECTING) {
              // 在判定关闭前尝试发送停止指令（只有在已OPEN时才可能发送）
              try {
                if (this.micWebsocket.readyState === WebSocket.OPEN) {
                  this.micWebsocket.send(JSON.stringify({
                    type: 'to-client-by-ip',
                    ip: this.boundClientId,
                    data: { action: 'stop-asr' }
                  }));
                  console.log(`连接超时：断开前已发送停止ASR指令到 ${this.boundClientId}`);
                }
              } catch (e) {
                console.error('连接超时：发送停止ASR指令失败', e);
              }
              this.micWebsocket.close();
              this.micWebsocket = null;
              this.isWebsocketConnected = false;
              this.$message({
                message: '连接超时，请检查网络连接',
                type: 'error',
                duration: 3000,
              });
            }
          }, 5000); // 5秒超时
        } else {
          // 清除重连定时器
          if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
          }
          this.reconnectAttempts = 0; // 重置重连计数器

          if (this.micWebsocket) {
            try {
              if (this.micWebsocket.readyState === WebSocket.OPEN) {
              this.micWebsocket.send(JSON.stringify({
                type: 'to-client-by-ip',
                ip: this.boundClientId,
                data: { action: 'stop-asr' }
              }));
              console.log(`断开前已发送停止ASR指令到客户端 IP ${this.boundClientId}`);
              }
            } catch (e) {
              console.error('发送停止ASR指令失败', e);
            }
            this.micWebsocket.close();
            this.micWebsocket = null;
          }
          this.isWebsocketConnected = false;
        }
      } catch (error) {
        console.error('WebSocket连接失败：', error);
        this.isWebsocketConnected = false;
        this.$message({
          message: '连接失败，请检查网络连接',
          type: 'error',
          duration: 3000,
        });
      }
    },

    setupWebsocketLifecycle(ws, name) {
      ws.onopen = () => {
        console.log(`${name} WebSocket 连接已建立`);
        this.isWebsocketConnected = true;
        this.reconnectAttempts = 0; // 重置重连计数器
        this.isUserInitiatedConnection = false; // 重置用户主动连接标志

        // 如果没有绑定IP，尝试从缓存加载
        if (!this.boundClientId) {
          const savedClientData = this.loadBoundClientFromCache();
          if (savedClientData) {
            this.boundClientId = savedClientData.ip;
            this.ipInputForm.ip = savedClientData.ip;
            console.log('从缓存恢复绑定IP:', this.boundClientId);
          }
        }

        // 发送Web端认证消息
        ws.send(JSON.stringify({
          type: 'auth',
          role: 'web',
          ip: this.boundClientId || '', // 如果没有IP，发送空字符串
          token: 'web_token_placeholder'
        }));
        console.log('已发送Web端认证消息', { ip: this.boundClientId || '(未提供)' });

        // 设置心跳
        this.startHeartbeat(ws);
      };
      // 监听消息
      ws.onmessage = (event) => {
        console.log(`${name} WebSocket 收到消息：`, event.data);
        this.lastPongTime = Date.now();

        // 判断是否为 JSON 格式
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          // 不是 JSON，可能是心跳或普通文本，直接忽略或根据需要处理
          // 例如：如果是 'pong'，可以不处理
          if (event.data === 'pong' || event.data === 'ping') {
            // 心跳包，什么都不做
            return;
          }
          // 其它非JSON消息
          console.warn('收到非JSON消息:', event.data);
          return;
        }

        // 下面是原有的 JSON 消息处理
        try {
          // 处理心跳响应
          if (data.type === 'heartbeat-response') {
            console.log('收到心跳响应:', data);
            // 心跳响应处理，更新lastPongTime已在上面处理
            return;
          }

          // 处理认证错误
          if (data.type === 'error') {
            console.error('WebSocket 认证失败:', data.message, data.code);
            // 如果是认证失败，停止重连并提示用户
            if (data.code === 'auth-failed') {
              this.allowReconnect = false; // 禁止重连
              this.reconnectAttempts = 0;
              
              // 清除重连定时器
              if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
              }
              
              // 停止心跳
              this.stopHeartbeat();
              
              // 根据错误消息类型处理
              if (data.message === '未提供IP地址') {
                // 未提供IP地址：尝试从缓存恢复或弹出输入框
                const savedClientData = this.loadBoundClientFromCache();
                if (savedClientData) {
                  this.boundClientId = savedClientData.ip;
                  this.ipInputForm.ip = savedClientData.ip;
                  console.log('从缓存恢复IP，准备重新连接:', this.boundClientId);
                  // 恢复IP后，允许重连
                  this.allowReconnect = true;
                  // 重新连接
                  this.connectWebsockets(true);
                } else {
                  // 没有缓存的IP，弹出输入框
                  this.showIpInputDialog = true;
                  this.$message({
                    message: '请配置客户端IP地址',
                    type: 'warning',
                    duration: 3000,
                  });
                }
              } else if (data.message?.includes('不在客户端列表中')) {
                // IP不在客户端列表中：清除缓存，弹出输入框，不自动重连
                console.warn('IP不在客户端列表中，清除缓存:', this.boundClientId);
                this.clearBoundClientCache();
                this.showIpInputDialog = true;
                this.$message({
                  message: `IP ${this.boundClientId || ''}不在客户端列表中，请重新配置`,
                  type: 'error',
                  duration: 5000,
                });
                // 如果有在线客户端列表，可以显示给用户
                if (data.onlineClients && Array.isArray(data.onlineClients) && data.onlineClients.length > 0) {
                  console.log('可用客户端列表:', data.onlineClients);
                  // 可以在这里将可用客户端列表显示给用户选择
                }
              } else {
                // 其他认证错误
                this.$message({
                  message: `认证失败: ${data.message || '未知错误'}`,
                  type: 'error',
                  duration: 3000,
                });
              }
              
              // 关闭连接
              ws.close();
              return;
            }
            // 其他类型的错误，继续处理
          }

          // 处理认证响应
          if (data.type === 'ok') {
            console.log('云端认证成功:', data.code);

            // 连接成功后，尝试恢复上次绑定的IP或弹出输入框
            if (!this.boundClientId) {
              const savedClientData = this.loadBoundClientFromCache();
              if (savedClientData) {
                this.boundClientId = savedClientData.ip;
                this.ipInputForm.ip = savedClientData.ip;
                console.log('从本地存储恢复绑定IP:', this.boundClientId);
                // 注意：此时客户端列表可能还未加载，验证将在handleClientListUpdate中进行
              } else {
                // 弹出IP输入框
                this.showIpInputDialog = true;
              }
            } else {
              // 如果有绑定的IP，等待客户端列表更新后再检查
              // 注意：IP检查应该在handleClientListUpdate中进行，而不是在这里
              console.log('认证成功，等待客户端列表更新...');
            }
            return;
          }

          // 处理client-list消息
          if (data.type === 'client-list' && data.clients) {
            this.handleClientListUpdate(data.clients);
            return;
          }

          // 处理asr-disconnected消息
          if (data.type === 'asr-disconnected') {
            console.log('收到ASR断开消息:', data);
            // 断开链接
            this.handleDisConnectClient();
            return;
          }

          // 处理来自客户端的消息
          if (data.type === 'from-client' && data.data) {
            // 检查消息是否已处理过（去重）
            if (data.messageId && this.processedMessages.has(data.messageId)) {
              console.log(`消息已处理过，跳过: ${data.messageId}`);
              return;
            }
            
            // 记录已处理的消息ID
            if (data.messageId) {
              this.processedMessages.add(data.messageId);
              // 限制消息ID集合大小，避免内存泄漏
              if (this.processedMessages.size > 1000) {
                const firstId = this.processedMessages.values().next().value;
                this.processedMessages.delete(firstId);
              }
            }
            
            console.log(`收到来自客户端 ${data.clientId} 的消息:`, data.data);

            // 只处理绑定客户端的消息
            if (!this.boundClientId || data.clientId !== this.boundClientId) {
              console.log(`忽略来自非绑定客户端 ${data.clientId} 的消息，当前绑定: ${this.boundClientId}`);
              return;
            }

            // 根据消息类型分别处理
            if (data.data.type === 'mic-transcription') {
              this.addConversationItem('你', data.data.text, data.data.timestamp);
            } else if (data.data.type === 'speaker-transcription') {
              this.addConversationItem('面试官', data.data.text, data.data.timestamp);
            } else if (data.data.type === 'quick_answer') {
              // 触发快答方法
              this.quickAnswerAction();
            } else if (data.data.type === 'deep_answer') {
              // 触发深度思考方法
              this.deepAnswerAction();
            } else if (data.data.type === 'screenshot') {
              // 触发截图方法
              this.handleClientScreenshotAnswer(data.data.imageData);
            }
          }
        } catch (error) {
          console.error('WebSocket消息业务处理失败:', error, '原始数据:', event.data);
        }
      };
      ws.onclose = () => {
        this.stopHeartbeat();
        this.isWebsocketConnected = false;
        this.isPeriodicAuth = false;

        // 只有在允许重连的情况下才尝试重连
        if (this.allowReconnect && this.reconnectAttempts < this.maxReconnectAttempts) {
          this.reconnectAttempts++;
          this.$message({
            message: `连接断开，正在尝试重连 (${this.reconnectAttempts}/${this.maxReconnectAttempts})`,
            type: 'warning',
            duration: 2000,
          });

          // 延迟重连
          this.reconnectTimer = setTimeout(() => {
            this.connectWebsockets(true);
          }, 2000);
        } else if (!this.allowReconnect) {
          // 不允许重连，重置计数器
          this.reconnectAttempts = 0;
          // 不显示提示，因为IP验证失败时已经有明确的错误提示

        } else {
          this.reconnectAttempts = 0;
          this.$message({
            message: '连接已断开，重连次数已达上限',
            type: 'error',
            duration: 3000,
          });
        }
      };
      ws.onerror = (error) => {
        console.error(`${name} WebSocket 错误:`, error);
        this.stopHeartbeat();
        this.isWebsocketConnected = false;
        this.isPeriodicAuth = false;
        this.$message({
          message: '云端连接出现错误',
          type: 'error',
          duration: 3000,
        });
      };
    },

    // 获取用户信息
    async getUserInfo() {
      // 准备登录信息

      const response = await getUserInfo(null)
      if (response.code === 200) {
        //  缓存当前登录用户信息
        this.balance = response.data.balance;
        this.remainingAnswerCount = Math.floor(this.balance / 3);
        // 获取用户快捷键配置
        const newShortcutKey = response.data.extraData.shortcutConfig || '';

        // 只有当快捷键配置发生变化时才重新设置
        if (newShortcutKey !== this.shortcutKey) {
          this.shortcutKey = newShortcutKey;
          if (this.shortcutKey) {
            console.log("用户截图快捷键配置已更新:", this.shortcutKey);
            this.setupGlobalShortcut();
          } else {
            // 如果快捷键被清空，移除监听器
            if (this.shortcutListener) {
              window.removeEventListener('keydown', this.shortcutListener, true);
              this.shortcutListener = null;
              this.isShortcutSetup = false;
              console.log("快捷键监听器已移除");
            }
          }
        }
      }
    },


    // 设置全局快捷键监听
    setupGlobalShortcut() {
      if (!this.shortcutKey) return;

      console.log('setupGlobalShortcut 被调用，当前快捷键:', this.shortcutKey);

      // 先移除旧监听器，无论是否已设置
      if (this.shortcutListener) {
        window.removeEventListener('keydown', this.shortcutListener, true);
        console.log('已移除旧的快捷键监听器');
      }

      // 重置设置标志
      this.isShortcutSetup = false;

      // 创建新的监听器
      this.shortcutListener = (event) => {
        // 立即设置处理中状态，防止重复触发
        if (this.isScreenshotProcessing) {
          console.log('截图处理中，忽略快捷键触发');
          return;
        }

        const pressedKeys = [];
        // 检查修饰键
        if (event.ctrlKey) pressedKeys.push('Ctrl');
        if (event.shiftKey) pressedKeys.push('Shift');
        if (event.altKey) pressedKeys.push('Alt');
        if (event.metaKey) pressedKeys.push('Meta');
        // 获取主键
        const key = event.key.toUpperCase();
        if (key !== 'CONTROL' && key !== 'SHIFT' && key !== 'ALT' && key !== 'META') {
          pressedKeys.push(key);
        }
        const pressedShortcut = pressedKeys.join('+');

        // 检查是否匹配用户设置的快捷键
        if (pressedShortcut === this.shortcutKey) {
          event.preventDefault();
          event.stopPropagation(); // 阻止事件冒泡
          event.stopImmediatePropagation(); // 阻止其他监听器
          console.log('快捷键触发截图:', pressedShortcut);
          this.handleScreenshotAnswer();
        }
      };

      // 添加监听器
      window.addEventListener('keydown', this.shortcutListener, true); // 使用捕获阶段
      this.isShortcutSetup = true;
      console.log('快捷键监听器设置完成，快捷键:', this.shortcutKey);
    },

    // 深度思考按钮点击事件
    handleDeepThinkClick(val, index, needDeepThink) {
      // 如果只传了两个参数（向后兼容），则index为undefined
      if (needDeepThink === undefined && typeof index === 'boolean') {
        needDeepThink = index;
        index = undefined;
      }
      this.handleQuickAnswerClick(val, index, needDeepThink);
    },
    //对话框快答按钮点击事件/深度思考按钮点击事件/快答回答按钮点击事件
    async handleQuickAnswerClick(val, index, needDeepThink) {
      console.log("快答按钮点击了");
      
      // 兼容旧的调用方式：如果只传了两个参数，第二个参数是needDeepThink
      if (needDeepThink === undefined && typeof index === 'boolean') {
        needDeepThink = index;
        index = undefined;
      }
      
      // 如果是从对话记录点击的（传入了索引），则拼接当前记录及前两条
      if (index !== undefined && index !== null && typeof index === 'number' && this.conversationList && this.conversationList.length > 0) {
        // 获取当前项及前两项的索引范围
        const startIndex = Math.max(0, index - 2); // 前两条的起始索引（不能小于0）
        const endIndex = index + 1; // 当前项索引+1（因为slice是左闭右开）
        
        // 获取需要拼接的对话记录
        const messagesToCombine = this.conversationList.slice(startIndex, endIndex);
        
        // 拼接对话内容，只放到问题修正区域，不修改原始记录
        this.questionAnalysis = messagesToCombine.map(item => item.content).join('\n');
        
        // 创建新的val对象用于后续处理，不修改原始的val（item）对象
        val = {
          content: this.questionAnalysis
        };
      } else if (!val) {
        // 如果不是从对话记录点击，且没有传入val，则使用问题修正区域的内容
        val = {
          content: this.questionAnalysis
        };
      } else {
        // 如果传入了val但没有索引（可能是从问题修正区域点击），直接使用val的内容
        this.questionAnalysis = val.content;
      }

      // 根据请求类型终止对应的请求
      if (needDeepThink) {
        // 深度思考请求：终止之前的深度思考请求
        if (this.isDeepThinkRequesting && this.currentAbortController3) {
          console.log("取消之前的深度思考请求", this.currentAbortController3);
          this.currentAbortController3.abort();
          console.log("已取消之前的深度思考请求");
          // 等待一小段时间确保请求被完全终止
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        // 创建新的深度思考 AbortController
        this.currentAbortController3 = new AbortController();
        this.isDeepThinkRequesting = true;
        this.deepThinkContent = ""; // 清空深度思考内容
        this.deepThinkReason = ""; // 清空思考过程内容
        this.deepThinkAnswer = ""; // 清空答案内容
        this.isReasonThinking = true;
      } else {
        // 快答请求：终止之前的快答请求
        if (this.isQuickAnswerRequesting && this.currentAbortController) {
          console.log("取消之前的快答请求", this.currentAbortController);
          this.currentAbortController.abort();
          console.log("已取消之前的快答请求");
          // 等待一小段时间确保请求被完全终止
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        // 创建新的快答 AbortController
        this.currentAbortController = new AbortController();
        this.isQuickAnswerRequesting = true;
        this.quickAnswerContent = ""; // 清空快答内容
      }

      // 面试官想问的问题（确保questionAnalysis已设置）
      if (val && !this.questionAnalysis) {
        this.questionAnalysis = val.content;
      }
      if (this.interviewInfo.status === 2) {
        this.$message({
          message: '面试已结束',
          type: 'error',
          duration: 1500,
        })
        return;
      }
      const contentInfoList = [];
      if (val) {
        this.store.questionNow = val.content;
        
         const contentInfo = {
           role: 'user',
           content: this.store.questionNow
         };
        contentInfoList.push(contentInfo);
      }
      const obj = {
        question: this.store.questionNow,
        onlineMode: this.formData.onlineMode,
        needDeepThink: needDeepThink,
        contentInfoList: contentInfoList, // 传递contentInfoList数组
      };
      const interviewId = this.$route.query.interviewId; // 从路由参数获取面试ID
      const url = `/api/interview/${interviewId}/ask`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.store.token,
          },
          body: JSON.stringify(obj),
          signal: needDeepThink ? this.currentAbortController3.signal : this.currentAbortController.signal, // 根据类型使用对应的 signal
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8', { fatal: false, ignoreBOM: true });
        
        // 使用缓冲区来累积不完整的数据块，确保严格按顺序处理
        let buffer = '';
        
        // 修复：避免使用常量条件的死循环
        let done = false;
        while (!done) {
          const result = await reader.read();
          done = result.done;
          
          if (result.value) {
            // 将新读取的数据追加到缓冲区
            // 如果流已结束，使用最终解码；否则使用流式解码
            buffer += decoder.decode(result.value, { stream: !done });
          } else if (done) {
            // 流结束时，进行最终解码以处理任何剩余字节
            buffer += decoder.decode();
          }
          
          // 按照 \n\n 分割完整的事件消息（SSE 格式）
          // 最后一个不完整的块保留在 buffer 中，等待下一次读取
          const parts = buffer.split('\n\n');
          
          // 保留最后一个可能不完整的块在 buffer 中
          buffer = parts.pop() || '';
          
          // 严格按顺序处理每个完整的消息块
          for (let i = 0; i < parts.length; i++) {
            const chunk = parts[i].trim();
            if (!chunk) continue;
            
            // 解析 SSE 格式：event: message\ndata: {...}
            const lines = chunk.split('\n');
            let eventLine = '';
            const dataLines = []; // 支持多行 data（SSE 规范允许多个 data: 行）
            
            // 按顺序查找 event 和所有 data 行
            for (const line of lines) {
              const trimmedLine = line.trim();
              if (trimmedLine.startsWith('event:')) {
                eventLine = trimmedLine;
              } else if (trimmedLine.startsWith('data:')) {
                // 收集所有 data 行（SSE 规范中多个 data 行需要拼接）
                dataLines.push(trimmedLine);
              }
            }
            
            // 只处理 event:message 的消息
            if (eventLine === 'event:message' && dataLines.length > 0) {
              // 拼接所有 data 行（SSE 规范：多个 data: 行用换行符拼接）
              let cleanDataLine = dataLines.map(line => {
                // 去除每行的 data: 前缀
                let cleaned = line.replace(/^data:\s*/, '');
                // 处理可能的重复前缀
                while (cleaned.startsWith('data:')) {
                  cleaned = cleaned.replace(/^data:\s*/, '');
                }
                return cleaned;
              }).join('\n'); // SSE 规范：多个 data 行用换行符拼接
              
              try {
                const data = JSON.parse(cleanDataLine);
                
                // 严格按照返回顺序累加内容，确保不丢失任何数据
                const reasonContent = data.reason_content || '';
                const answerContent = data.answer_content || '';
                
                if (needDeepThink) {
                  // 深度思考模式：累加完整内容和分别的内容
                  this.deepThinkContent += reasonContent + answerContent;
                  if (reasonContent) {
                    this.deepThinkReason += reasonContent;
                  }
                  if (answerContent) {
                    this.deepThinkAnswer += answerContent;
                  }
                } else {
                  // 快答模式：严格按照顺序累加
                  this.quickAnswerContent += reasonContent + answerContent;
                }
              } catch (e) {
                // JSON 解析失败时，尝试从不完整 JSON 中提取内容，确保不丢失数据
                console.warn('解析流式数据失败:', e, '原始数据:', cleanDataLine);
                
                // 尝试使用正则表达式提取 JSON 字段值，即使 JSON 不完整也能提取部分内容
                let reasonContent = '';
                let answerContent = '';
                
                // 尝试提取 reason_content 字段值（支持转义字符）
                const reasonMatch = cleanDataLine.match(/"reason_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (reasonMatch && reasonMatch[1]) {
                  reasonContent = reasonMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                // 尝试提取 answer_content 字段值（支持转义字符）
                const answerMatch = cleanDataLine.match(/"answer_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (answerMatch && answerMatch[1]) {
                  answerContent = answerMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                // 即使解析失败，也要将提取的内容拼接到原位置，确保顺序和完整性
                if (reasonContent || answerContent) {
                  if (needDeepThink) {
                    this.deepThinkContent += reasonContent + answerContent;
                    if (reasonContent) {
                      this.deepThinkReason += reasonContent;
                    }
                    if (answerContent) {
                      this.deepThinkAnswer += answerContent;
                    }
                  } else {
                    this.quickAnswerContent += reasonContent + answerContent;
                  }
                }
              }
            }
          }
          
          // 如果流已经结束，处理剩余的 buffer
          if (done && buffer.trim()) {
            // 流结束时尝试处理最后一个可能不完整的块
            const lines = buffer.split('\n');
            let eventLine = '';
            const dataLines = []; // 支持多行 data（SSE 规范允许多个 data: 行）
            
            for (const line of lines) {
              const trimmedLine = line.trim();
              if (trimmedLine.startsWith('event:')) {
                eventLine = trimmedLine;
              } else if (trimmedLine.startsWith('data:')) {
                // 收集所有 data 行（SSE 规范中多个 data 行需要拼接）
                dataLines.push(trimmedLine);
              }
            }
            
            if (eventLine === 'event:message' && dataLines.length > 0) {
              // 拼接所有 data 行（SSE 规范：多个 data: 行用换行符拼接）
              let cleanDataLine = dataLines.map(line => {
                // 去除每行的 data: 前缀
                let cleaned = line.replace(/^data:\s*/, '');
                // 处理可能的重复前缀
                while (cleaned.startsWith('data:')) {
                  cleaned = cleaned.replace(/^data:\s*/, '');
                }
                return cleaned;
              }).join('\n'); // SSE 规范：多个 data 行用换行符拼接
              
              try {
                const data = JSON.parse(cleanDataLine);
                const reasonContent = data.reason_content || '';
                const answerContent = data.answer_content || '';
                
                appendDeepThinkSegments(reasonContent, answerContent);
              } catch (e) {
                // JSON 解析失败时，尝试从不完整 JSON 中提取内容，确保不丢失数据
                console.warn('解析流式数据（最后一块）失败:', e, '原始数据:', cleanDataLine);
                
                // 尝试使用正则表达式提取 JSON 字段值，即使 JSON 不完整也能提取部分内容
                let reasonContent = '';
                let answerContent = '';
                
                // 尝试提取 reason_content 字段值（支持转义字符）
                const reasonMatch = cleanDataLine.match(/"reason_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (reasonMatch && reasonMatch[1]) {
                  reasonContent = reasonMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                // 尝试提取 answer_content 字段值（支持转义字符）
                const answerMatch = cleanDataLine.match(/"answer_content"\s*:\s*"((?:[^"\\]|\\.)*)"/);
                if (answerMatch && answerMatch[1]) {
                  answerContent = answerMatch[1]
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t')
                    .replace(/\\"/g, '"')
                    .replace(/\\\\/g, '\\');
                }
                
                appendDeepThinkSegments(reasonContent, answerContent);
              }
            }
            buffer = '';
          }
        }
        console.log("快答请求成功");
        // const assistentInfo = {
        //   role: 'assistant',
        //   content: needDeepThink ? this.deepThinkContent : this.quickAnswerContent
        // };
        // this.formData.contentInfoList.push(assistentInfo);
        // 记录快答历史
        if (!needDeepThink && this.questionAnalysis && this.quickAnswerContent) {
          const interviewId = this.$route.query.interviewId;
          this.store.addAnswerRecordByInterviewId(interviewId, this.questionAnalysis, this.quickAnswerContent, undefined, undefined);
        }
        if (needDeepThink && this.questionAnalysis && this.deepThinkAnswer) {
          const interviewId = this.$route.query.interviewId;
          this.store.addAnswerRecordByInterviewId(interviewId, this.questionAnalysis, undefined, this.deepThinkAnswer, undefined);
        }
      } catch (error) {
        // 检查是否是取消请求导致的错误
        if (error.name === 'AbortError') {
          console.log("请求已被取消");
          return;
        }
        console.error("快答请求失败:", error);
      } finally {
        // 请求完成后清理对应的 AbortController 和状态
        if (needDeepThink) {
          this.currentAbortController3 = null;
          this.isDeepThinkRequesting = false;
          this.isReasonThinking = false;
        } else {
          this.currentAbortController = null;
          this.isQuickAnswerRequesting = false;
        }
      }
    },
    //重新回答按钮点击事件
    handleRegenerate() {
      console.log("重新回答按钮点击了");
      if (this.interviewInfo.status === 2) {
        this.$message({
          message: '面试已结束',
          type: 'error',
          duration: 1500,
        })
      }
      if (this.quickAnswerContent && this.quickAnswerContent.trim() !== '') {
        this.handleRegenerate2(false);
      }
      if (this.deepThinkReason && this.deepThinkReason.trim() !== '') {
        this.handleRegenerate3(true);
      }
    },
    //重新回答按钮点击事件(快答)
    async handleRegenerate2(needDeepThink) {
      console.log("重新回答按钮点击了");

      // 只终止快答请求
      if (this.isQuickAnswerRequesting && this.currentAbortController) {
        console.log("取消之前的快答请求", this.currentAbortController);
        this.currentAbortController.abort();
        console.log("已取消之前的快答请求");
        // 等待一小段时间确保请求被完全终止
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // 创建新的快答 AbortController
      this.currentAbortController = new AbortController();
      this.isQuickAnswerRequesting = true;

      this.quickAnswerContent = ""; // 清空旧内容
      const contentInfoList = [];
      if (!needDeepThink) {
        const contentInfo = {
          role: 'user',
          content: this.questionAnalysis
        };
        contentInfoList.push(contentInfo);
      }

      const obj = {
        question: this.questionAnalysis,
        onlineMode: this.formData.onlineMode,
        needDeepThink: needDeepThink,
        contentInfoList: contentInfoList // 传递contentInfoList数组
      };
      const interviewId = this.$route.query.interviewId; // 从路由参数获取面试ID
      const url = `/api/interview/${interviewId}/ask`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.store.token,
          },
          body: JSON.stringify(obj),
          signal: this.currentAbortController.signal, // 添加 signal 用于取消请求
        });
        console.log(response);
        if (!response.ok) throw new Error("请求失败");

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        if (needDeepThink) {
          this.deepThinkContent = ""; // 清空旧内容
          this.deepThinkReason = ""; // 清空思考过程内容
          this.deepThinkAnswer = ""; // 清空答案内容
        } else {
          this.quickAnswerContent = ""; // 清空旧内容
        }

        // 使用循环条件替代常量条件，修复 lint 报错
        let done = false;
        while (!done) {
          const result = await reader.read();
          done = result.done;
          if (done) break;

          const dataStr = decoder.decode(result.value);
          // 处理流式数据（格式：event: message\ndata: {...}\n\n）
          dataStr.split("\n\n").forEach((chunk) => {
            if (!chunk) return;
            const [eventLine, dataLine] = chunk.split("\n");
            if (eventLine === "event:message" && dataLine.startsWith("data:")) {
              const cleanDataLine = dataLine.replace(/^data:data:\s*/, "").replace(/^data:\s*/, ""); // 去除开头所有data:前缀
              try {
                const data = JSON.parse(cleanDataLine);
                if (needDeepThink) {
                  this.deepThinkContent +=
                    data.reason_content + data.answer_content; // 累加流式内容
                  // 分别处理思考过程和答案
                  if (data.reason_content) {
                    this.deepThinkReason += data.reason_content;
                  }
                  if (data.answer_content) {
                    this.deepThinkAnswer += data.answer_content;
                  }
                  console.log("deepThinkContent", this.deepThinkContent);
                } else {
                  this.quickAnswerContent +=
                    data.reason_content + data.answer_content;
                }
              } catch (e) {
                console.error("JSON parse error:", e, "on data:", cleanDataLine);
                return;
              }

            }
          });
        }
        console.log("快答请求成功");
        if (!needDeepThink) {
          // const contentInfo = {
          //   role: 'assistant',
          //   content: this.quickAnswerContent
          // };
          // this.formData.contentInfoList.push(contentInfo);
        }
        // === 新增：存储问答记录 ===
        if (!needDeepThink && this.questionAnalysis && this.quickAnswerContent) {
          const interviewId = this.$route.query.interviewId;
          this.store.addAnswerRecordByInterviewId(interviewId, this.questionAnalysis, this.quickAnswerContent, undefined, undefined);
        }
        if (needDeepThink && this.questionAnalysis && this.deepThinkAnswer) {
          const interviewId = this.$route.query.interviewId;
          this.store.addAnswerRecordByInterviewId(interviewId, this.questionAnalysis, undefined, this.deepThinkAnswer, undefined);
        }
      } catch (error) {
        // 检查是否是取消请求导致的错误
        if (error.name === 'AbortError') {
          console.log("请求已被取消");
          return;
        }
        console.error("快答请求失败:", error);
      } finally {
        // 请求完成后清理 AbortController 和状态
        this.currentAbortController = null;
        this.isQuickAnswerRequesting = false;
      }
    },
    //重新回答按钮点击事件(深度思考)
    async handleRegenerate3(needDeepThink) {
      console.log("重新回答按钮点击了");

      // 只终止深度思考请求
      if (this.isDeepThinkRequesting && this.currentAbortController3) {
        console.log("取消之前的深度思考请求", this.currentAbortController3);
        this.currentAbortController3.abort();

        // 等待一小段时间确保请求被完全终止
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // 创建新的深度思考 AbortController
      this.currentAbortController3 = new AbortController();
      this.isDeepThinkRequesting = true;

      this.deepThinkContent = ""; // 清空旧内容
      this.deepThinkReason = ""; // 清空思考过程内容
      this.deepThinkAnswer = ""; // 清空答案内容
      this.isReasonThinking = true;
      const contentInfoList = [];
      if (!needDeepThink) {
        const contentInfo = {
          role: 'user',
          content: this.questionAnalysis
        };
        contentInfoList.push(contentInfo);
      }

      const obj = {
        question: this.questionAnalysis,
        onlineMode: this.formData.onlineMode,
        needDeepThink: needDeepThink,
        contentInfoList: contentInfoList // 传递contentInfoList数组
      };
      const interviewId = this.$route.query.interviewId; // 从路由参数获取面试ID
      const url = `/api/interview/${interviewId}/ask`;

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.store.token,
          },
          body: JSON.stringify(obj),
          signal: this.currentAbortController3.signal, // 添加 signal 用于取消请求
        });
        if (!response.ok) throw new Error("请求失败");

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        if (needDeepThink) {
          this.deepThinkContent = ""; // 清空旧内容
          this.deepThinkReason = ""; // 清空思考过程内容
          this.deepThinkAnswer = ""; // 清空答案内容
        } else {
          this.quickAnswerContent = ""; // 清空旧内容
        }

        // 使用循环条件替代常量条件，修复 lint 报错
        let done = false;
        while (!done) {
          const result = await reader.read();
          done = result.done;
          if (done) break;

          const dataStr = decoder.decode(result.value);
          // 处理流式数据（格式：event: message\ndata: {...}\n\n）
          dataStr.split("\n\n").forEach((chunk) => {
            if (!chunk) return;
            const [eventLine, dataLine] = chunk.split("\n");
            if (eventLine === "event:message" && dataLine.startsWith("data:")) {
              const cleanDataLine = dataLine.replace(/^data:data:\s*/, "").replace(/^data:\s*/, ""); // 去除开头所有data:前缀
              try {
                const data = JSON.parse(cleanDataLine);
                if (needDeepThink) {
                  this.deepThinkContent +=
                    data.reason_content + data.answer_content; // 累加流式内容
                  // 分别处理思考过程和答案
                  if (data.reason_content) {
                    this.deepThinkReason += data.reason_content;
                  }
                  if (data.answer_content) {
                    this.deepThinkAnswer += data.answer_content;
                  }
                } else {
                  this.quickAnswerContent +=
                    data.reason_content + data.answer_content;
                }
              } catch (e) {
                console.error("JSON parse error:", e, "on data:", cleanDataLine);
                return;
              }

            }
          });
        }
        if (!needDeepThink) {
          // const contentInfo = {
          //   role: 'assistant',
          //   content: this.quickAnswerContent
          // };
          // this.formData.contentInfoList.push(contentInfo);
        }
        // === 新增：存储问答记录 ===
        if (!needDeepThink && this.questionAnalysis && this.quickAnswerContent) {
          const interviewId = this.$route.query.interviewId;
          this.store.addAnswerRecordByInterviewId(interviewId, this.questionAnalysis, this.quickAnswerContent, undefined, undefined);
        }
        if (needDeepThink && this.questionAnalysis && this.deepThinkAnswer) {
          const interviewId = this.$route.query.interviewId;
          this.store.addAnswerRecordByInterviewId(interviewId, this.questionAnalysis, undefined, this.deepThinkAnswer, undefined);
        }
      } catch (error) {
        // 检查是否是取消请求导致的错误
        if (error.name === 'AbortError') {
          console.log("请求已被取消");
          return;
        }
        console.error("快答请求失败:", error);
      } finally {
        // 请求完成后清理 AbortController 和状态
        this.currentAbortController3 = null;
        this.isDeepThinkRequesting = false;
        this.isReasonThinking = false;
      }
    },
    // 获取面试信息
    async getInterviewInfo(val) {
      const response = await interviewInfo(val);
      if (response.code === 200) {
        this.interviewInfo = response.data;
        console.log("面试信息", this.interviewInfo);
        this.startTime = this.interviewInfo.startTime;
        this.answeredCount = this.interviewInfo.agTotalCount;
        // 新增：根据startTime初始化计时器
        if (this.startTime) {
          const start = new Date(this.startTime.replace(/-/g, '/')).getTime();
          const now = Date.now();
          let diff = Math.max(0, Math.floor((now - start) / 1000));
          this.hours = Math.floor(diff / 3600);
          this.minutes = Math.floor((diff % 3600) / 60);
          this.seconds = diff % 60;
        }
        this.startTimer();
        // 页面加载时自动连接客户端（如果未连接且面试状态为进行中）
        if (this.interviewInfo.status === 1 && !this.isInterviewEnded) {
          this.connectWebsockets(true);
        }
      }
    },

    startTimer() {
      // 防止重复启动计时器
      if (this.timer) return;

      this.timer = setInterval(() => {
        this.seconds++;
        if (this.seconds >= 60) {
          this.seconds = 0;
          this.minutes += 1;
        }
        if (this.minutes >= 60) {
          this.minutes = 0;
          this.hours += 1;
        }
      }, 1000); // 每1000毫秒 = 1秒
    },
    // 处理设置按钮点击事件
    handleSettingsClick() {
      // 处理点击事件，例如跳转到设置页面
      console.log("Settings clicked!");
      // 示例：跳转到设置页面
      this.dialogSettingVisible = true;
      // this.$router.push('/settings');
    },
    // 处理重新回答按钮点击事件
    updateAnswerCount() {
      // 更新已回答次数和剩余回答次数的逻辑
      // 这里只是一个示例，实际应用中需要根据具体业务逻辑来实现
      this.answeredCount += 1;
      this.remainingAnswerCount -= 1;
    },
    // 处理结束面试按钮点击事件
    handleEndInterview() {
      interviewEnd(this.$route.query.interviewId).then((response) => {
        if (response.code === 200) {
          // 设置面试结束标志
          this.isInterviewEnded = true;
          
          // 断开WebSocket连接
          if (this.micWebsocket) {
            this.allowReconnect = false; // 禁止重连
            this.connectWebsockets(false);
          }
          
          // 结束面试成功，清除IP缓存
          this.clearBoundClientCache();
          // 跳转到面试完成页面
          this.$router.push("/interview-completed");
        }
      })
    },

    // 处理停止回答按钮点击事件
    stopAnswer() {
      console.log("停止回答按钮被点击");
      // 取消所有正在进行的请求
      if (this.currentAbortController) {
        console.log("取消快答请求");
        this.currentAbortController.abort();
        this.currentAbortController = null;
      }
      if (this.currentAbortController3) {
        console.log("取消深度思考/截图回答请求");
        this.currentAbortController3.abort();
        this.currentAbortController3 = null;
      }
      // 重置状态
      this.isQuickAnswerRequesting = false;
      this.isDeepThinkRequesting = false;
      this.isReasonThinking = false;
      // 显示提示信息
      this.$message({
        message: '已停止回答',
        type: 'info',
        duration: 1500,
      });
    },
    // 恢复推拉功能相关代码
    startResize(e) {
      // 兼容鼠标和触摸
      e.preventDefault && e.preventDefault();
      this.isResizing = true;
      // 支持 touch 事件
      if (e.type === 'touchstart') {
        this.startX = e.touches[0].clientX;
        document.addEventListener('touchmove', this.handleResize, { passive: false });
        document.addEventListener('touchend', this.stopResize);
      } else {
        this.startX = e.clientX;
        document.addEventListener('mousemove', this.handleResize);
        document.addEventListener('mouseup', this.stopResize);
      }
      this.startQuickFlex = this.quickAnswerFlex;
      this.startDeepFlex = this.deepAnswerFlex;
    },

    handleResize(e) {
      if (!this.isResizing) return;
      let clientX;
      if (e.type === 'touchmove') {
        clientX = e.touches[0].clientX;
        e.preventDefault && e.preventDefault(); // 防止页面滚动
      } else {
        clientX = e.clientX;
      }
      const deltaX = clientX - this.startX;
      const totalFlex = this.startQuickFlex + this.startDeepFlex;
      const containerWidth = document.querySelector('.answer-panels').offsetWidth - 32;
      const flexChange = (deltaX / containerWidth) * totalFlex;
      this.quickAnswerFlex = Math.max(0.1, this.startQuickFlex + flexChange);
      this.deepAnswerFlex = Math.max(0.1, this.startDeepFlex - flexChange);
    },

    stopResize(e) {
      this.isResizing = false;
      if (e && e.type === 'touchend') {
        document.removeEventListener('touchmove', this.handleResize);
        document.removeEventListener('touchend', this.stopResize);
      } else {
        document.removeEventListener('mousemove', this.handleResize);
        document.removeEventListener('mouseup', this.stopResize);
      }
    },
    // 切换布局
    toggleDirection() {
      // 切换深度区域和快答区域的显示状态
      if(this.showDeepContent && this.showQuickContent){
        this.showQuickContent = true;
        this.showDeepContent = false;
      }else if(this.showDeepContent && !this.showQuickContent){
        this.showDeepContent = true;
        this.showQuickContent = true;
      } else if(!this.showDeepContent && this.showQuickContent){
        this.showDeepContent = true;
        this.showQuickContent = false;
      } 
      // this.showDeepContent = !this.showDeepContent;
      // this.showQuickContent = !this.showDeepContent;
    },

    // 从缓存中加载对话列表
    loadConversationFromStore() {
      const interviewId = this.$route.query.interviewId;
      if (interviewId) {
        const cachedConversation = this.store.getConversationByInterviewId(interviewId);
        if (cachedConversation && cachedConversation.length > 0) {
          this.conversationList = [...cachedConversation];
          this.isConversationEmpty = false;
          console.log('从缓存中加载对话列表:', this.conversationList);
        }
      }
    },
    // 添加对话项到对话列表
    addConversationItem(speaker, content, timestamp) {
      // 验证输入参数
      if (!speaker || !content) {
        console.warn('无效的对话项数据:', { speaker, content, timestamp });
        return;
      }
      // 格式化时间戳
      let formattedTime = '00:00';
      let timestampMs = null;
      try {
        const date = new Date(timestamp);
        if (!isNaN(date.getTime())) {
          timestampMs = date.getTime();
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          formattedTime = `${hours}:${minutes}`;
        }
      } catch (error) {
        console.warn('时间戳格式化失败:', timestamp, error);
      }
      // 检查是否为空内容
      const trimmedContent = content.trim();
      if (!trimmedContent) {
        console.warn('跳过空内容的对话项');
        return;
      }
      // 检查是否需要合并到上一个对话项
      if (this.conversationList.length > 0 && timestampMs) {
        const lastItem = this.conversationList[this.conversationList.length - 1];
        // 检查是否是同一个说话者
        if (lastItem.speaker === speaker) {
          // 检查时间间隔是否不超过3秒
          // 使用最近的一次时间戳与最新的时间戳进行比较
          const lastTimestamp = new Date(lastItem.originalTimestamp || lastItem.timestamp).getTime();
          const timeDiff = Math.abs(timestampMs - lastTimestamp);
          if (timeDiff <= 20) { // 3秒 = 3000毫秒
            // 合并内容到上一个对话项
            lastItem.content += ' ' + trimmedContent;
            // 不更新时间戳，保持原始时间戳显示
            lastItem.originalTimestamp = timestamp; // 保存最新的原始时间戳用于后续比较

            console.log('已合并对话项:', { speaker, content: trimmedContent, timeDiff });

            // 实时更新缓存中的对话列表
            const interviewId = this.$route.query.interviewId;
            if (interviewId) {
              this.store.setConversationByInterviewId(interviewId, this.conversationList);
              console.log('已更新缓存中的对话列表');
            }
            // 自动滚动到底部
            this.$nextTick(() => {
              this.scrollMessagesToBottom();
            });
            return;
          }
        }
      }
      // 创建新的对话项
      const conversationItem = {
        speaker: speaker,
        content: trimmedContent,
        timestamp: formattedTime,
        originalTimestamp: timestamp // 保存原始时间戳用于后续比较
      };

      // 添加到对话列表
      this.conversationList.push(conversationItem);

      // 实时更新缓存中的对话列表
      const interviewId = this.$route.query.interviewId;
      if (interviewId) {
        this.store.setConversationByInterviewId(interviewId, this.conversationList);
        console.log('已更新缓存中的对话列表');
      }

      // 更新对话列表状态
      this.isConversationEmpty = false;

      // 自动滚动到底部
      this.$nextTick(() => {
        this.scrollMessagesToBottom();
      });

      console.log('已添加对话项:', conversationItem);
    },

    // 切换思考过程的收起/展开状态
    toggleThinking() {
      this.isThinkingCollapsed = !this.isThinkingCollapsed;
    },
    scrollQuickAnswerToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.quickAnswerContentRef;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    scrollMessagesToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.messagesContainer;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    scrollDeepReasonToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.deepReasonContainer;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    scrollDeepAnswerToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.deepAnswerContainer;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    saveAnswerCache() {
      const interviewId = this.$route.query.interviewId;
      if (!interviewId) return;
      this.store.setAnswerCacheByInterviewId(interviewId, {
        quickAnswerContent: this.quickAnswerContent,
        deepThinkReason: this.deepThinkReason,
        deepThinkAnswer: this.deepThinkAnswer,
        questionAnalysis: this.questionAnalysis
      });
    },
    loadAnswerCache() {
      const interviewId = this.$route.query.interviewId;
      if (!interviewId) return;
      const cache = this.store.getAnswerCacheByInterviewId(interviewId);
      if (cache) {
        this.quickAnswerContent = cache.quickAnswerContent || '';
        this.deepThinkReason = cache.deepThinkReason || '';
        this.deepThinkAnswer = cache.deepThinkAnswer || '';
        this.questionAnalysis = cache.questionAnalysis || '';
      }
    },
    openInterviewSettings() {
      console.log('打开面试设置');
      this.dialogSettingVisible = true;
      this.currentTab = 'basic';
      this.settingName = '面试设置'
    },
    openShortcutSettings() {
      console.log('打开面试设置');
      this.dialogSettingVisible = true;
      this.currentTab = 'shortcut';
      this.settingName = '快捷键设置'
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      if (this.isDarkMode) {
        document.body.classList.add('dark-mode');
        localStorage.setItem('isDarkMode', '1');
        // 直接设置竖条的深色模式样式
        this.$nextTick(() => {
          const areaBars = document.querySelectorAll('.area-bar-vertical');
          areaBars.forEach(bar => {
            bar.style.background = '#6a707b';
            bar.style.borderLeftColor = '#333';
            bar.style.borderRightColor = '#333';
          });

          // 设置思考过程和答案区域的深色模式样式
          const thinkingSections = document.querySelectorAll('.thinking-section');
          thinkingSections.forEach(section => {
            section.style.background = '#6a707b';
          });

          const answerSections = document.querySelectorAll('.answer-section');
          answerSections.forEach(section => {
            section.style.background = '#6a707b';
          });

          const thinkingHeaders = document.querySelectorAll('.thinking-header');
          thinkingHeaders.forEach(header => {
            header.style.background = '#6a707b';
          });

          const answerHeaders = document.querySelectorAll('.answer-header');
          answerHeaders.forEach(header => {
            header.style.background = '#6a707b';
          });

          // 确保按钮在深色模式下保持蓝色背景
          const reanswerBtns = document.querySelectorAll('.reanswer-btn');
          reanswerBtns.forEach(btn => {
            btn.style.background = '#1890ff !important';
            btn.style.color = '#fff !important';
            btn.style.borderColor = '#1890ff !important';
            btn.setAttribute('style', btn.getAttribute('style') + '; background: #1890ff !important; color: #fff !important; border-color: #1890ff !important;');
          });
          // 新增：暗色模式切换后对表格执行暗色修正
          this.applyDarkTableFix();
        });
      } else {
        document.body.classList.remove('dark-mode');
        localStorage.setItem('isDarkMode', '0');
        // 恢复竖条的浅色模式样式
        this.$nextTick(() => {
          const areaBars = document.querySelectorAll('.area-bar-vertical');
          areaBars.forEach(bar => {
            bar.style.background = '#ffffff';
            bar.style.borderLeftColor = '#e5e6eb';
            bar.style.borderRightColor = '#e5e6eb';
          });

          // 恢复思考过程和答案区域的浅色模式样式
          const thinkingSections = document.querySelectorAll('.thinking-section');
          thinkingSections.forEach(section => {
            section.style.background = '#fafbfc';
          });

          const answerSections = document.querySelectorAll('.answer-section');
          answerSections.forEach(section => {
            section.style.background = '#fff';
          });

          const thinkingHeaders = document.querySelectorAll('.thinking-header');
          thinkingHeaders.forEach(header => {
            header.style.background = '#f0f2f5';
          });

          const answerHeaders = document.querySelectorAll('.answer-header');
          answerHeaders.forEach(header => {
            header.style.background = '#f6ffed';
          });

          // 恢复按钮的浅色模式样式
          const reanswerBtns = document.querySelectorAll('.reanswer-btn');
          reanswerBtns.forEach(btn => {
            btn.style.background = '#1890ff !important';
            btn.style.color = '#fff !important';
            btn.style.borderColor = '#1890ff !important';
            btn.setAttribute('style', btn.getAttribute('style') + '; background: #1890ff !important; color: #fff !important; border-color: #1890ff !important;');
          });
          // 新增：切换为浅色模式后，移除表格的暗色内联覆盖
          this.clearDarkTableFix();
        });
      }
    },
    openAudioSettings() {
      console.log('打开音频设置');
    },
    toggleConnection() {
      this.formData.onlineMode = !this.formData.onlineMode;
      console.log('切换联网状态', this.formData.onlineMode);
    },
    deepAnswerAction() {
      console.log('深度分析');
      this.questionAnalysis = '';
      // 如果问题修正内容为空，则取对话列表最后三个对话内容拼接
      if (!this.questionAnalysis) {
        const lastThreeMessages = this.conversationList.slice(-3);
        this.questionAnalysis = lastThreeMessages.map(item => item.content).join('\n');
      }
      this.handleDeepThinkClick(null, true);
    },
    quickAnswerAction() {
      console.log('快速回答');
      this.questionAnalysis = '';
      // 如果问题修正内容为空，则取对话列表最后三个对话内容拼接
      if (!this.questionAnalysis) {
        const lastThreeMessages = this.conversationList.slice(-3);
        this.questionAnalysis = lastThreeMessages.map(item => item.content).join('\n');
      }
      this.handleQuickAnswerClick(null, false);
    },
    recordWebsocketUsage(id) {
      // 如果WebSocket未连接，直接返回，不执行扣费
      if (!this.isWebsocketConnected) {
        console.log('WebSocket未连接，跳过扣费操作');
        this.websocketUsageFailCount = 0;  // 重置失败计数器
        return;
      }
      
      // 这里可以自定义data内容
      const data = {
        durationSeconds: 60, //使用时长（秒）
        costInCents: 10 // 扣费金额（分）
      };
      // 调用后端接口
      recordUsage(id, data).then(res=>{
        if(res.code==200){
          console.log('recordUsage成功');
          this.websocketUsageFailCount = 0;  // 成功时重置失败计数器
        }else{
          this.websocketUsageFailCount++;  // 失败时增加计数
          console.warn(`扣费失败 (连续失败${this.websocketUsageFailCount}/${this.maxUsageFailAttempts}次): ${res.message || '未知错误'}`);
          
          // 只有连续3次失败才断开
          if(this.websocketUsageFailCount >= this.maxUsageFailAttempts){
            console.error('连续扣费失败3次，断开WebSocket连接');
            // 扣费失败，禁止重连
            this.allowReconnect = false;
            this.websocketUsageFailCount = 0;  // 重置计数器，避免无限循环
            this.reconnectAttempts = 0;
            
            // 清除重连定时器
            if (this.reconnectTimer) {
              clearTimeout(this.reconnectTimer);
              this.reconnectTimer = null;
            }
            
            // 发送断开消息，并断开WebSocket连接
            if (this.micWebsocket && this.micWebsocket.readyState === WebSocket.OPEN) {
              try {
                this.micWebsocket.send(JSON.stringify({
                  type: 'to-client-by-ip',
                  ip: this.boundClientId,
                  data: { action: 'stop-asr' }
                }));
                console.log(`连续扣费失败：断开前已发送停止ASR指令到 ${this.boundClientId}`);
              } catch (e) {
                console.error('连续扣费失败：发送停止ASR指令失败', e);
              }
            }
            
            // 关闭WebSocket连接
            if (this.micWebsocket) {
              this.micWebsocket.close();
              this.micWebsocket = null;
            }
            
            this.connectWebsockets(false);
            
            this.$message({
              message: '连续扣费失败3次，连接已断开',
              type: 'error',
              duration: 5000,
            });
          }
        }
      }).catch(err=>{
        this.websocketUsageFailCount++;  // 网络错误也计入失败计数
        console.error(`扣费请求失败 (连续失败${this.websocketUsageFailCount}/${this.maxUsageFailAttempts}次):`, err);
        
        // 只有连续3次失败才断开
        if(this.websocketUsageFailCount >= this.maxUsageFailAttempts){
          console.error('连续扣费失败3次，断开WebSocket连接');
          // 扣费失败，禁止重连
          this.allowReconnect = false;
          this.websocketUsageFailCount = 0;  // 重置计数器，避免无限循环
          this.reconnectAttempts = 0;
          
          // 清除重连定时器
          if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
          }
          
          // 发送断开消息，并断开WebSocket连接
          if (this.micWebsocket && this.micWebsocket.readyState === WebSocket.OPEN) {
            try {
              this.micWebsocket.send(JSON.stringify({
                type: 'to-client-by-ip',
                ip: this.boundClientId,
                data: { action: 'stop-asr' }
              }));
              console.log(`连续扣费失败：断开前已发送停止ASR指令到 ${this.boundClientId}`);
            } catch (e) {
              console.error('连续扣费失败：发送停止ASR指令失败', e);
            }
          }
          
          // 关闭WebSocket连接
          if (this.micWebsocket) {
            this.micWebsocket.close();
            this.micWebsocket = null;
          }
          
          this.connectWebsockets(false);
          
          this.$message({
            message: '连续扣费失败3次，连接已断开',
            type: 'error',
            duration: 5000,
          });
        }
      });
    },

    // 设置页面可见性监听器
    setupVisibilityListener() {
      const handleVisibilityChange = () => {
        this.isPageVisible = !document.hidden;
        console.log(`页面可见性变化: ${this.isPageVisible ? '可见' : '隐藏'}`);
        
        if (this.isPageVisible) {
          // 页面重新可见时，立即发送一次心跳检测连接
          if (this.micWebsocket && this.micWebsocket.readyState === WebSocket.OPEN) {
            try {
              this.micWebsocket.send('ping');
              console.log('页面恢复可见，发送心跳检测');
            } catch (error) {
              console.error('心跳检测失败:', error);
            }
          }
        }
      };
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      
      // 保存引用以便后续清理
      this.visibilityChangeHandler = handleVisibilityChange;
    },

    // 清理页面可见性监听器
    removeVisibilityListener() {
      if (this.visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.visibilityChangeHandler = null;
        console.log('已清理页面可见性监听器');
      }
    },

    // IP缓存管理方法
    saveBoundClientToCache(ip) {
      const cacheData = {
        ip: ip,
        timestamp: Date.now(),
        expiry: 3 * 60 * 60 * 1000 // 3小时的有效期（毫秒）
      };
      localStorage.setItem('boundClientId', JSON.stringify(cacheData));
      console.log('IP缓存已保存:', cacheData);
    },

    loadBoundClientFromCache() {
      try {
        const cachedData = localStorage.getItem('boundClientId');
        if (!cachedData) {
          return null;
        }

        const cacheData = JSON.parse(cachedData);
        const now = Date.now();
        
        // 检查缓存是否过期
        if (now - cacheData.timestamp > cacheData.expiry) {
          console.log('IP缓存已过期，清除缓存');
          localStorage.removeItem('boundClientId');
          return null;
        }

        console.log('从缓存加载IP:', cacheData.ip);
        this.boundClientId = cacheData.ip;
        this.ipInputForm.ip = cacheData.ip;
        return cacheData;
      } catch (error) {
        console.error('加载IP缓存失败:', error);
        // 如果解析失败，清除无效的缓存
        localStorage.removeItem('boundClientId');
        return null;
      }
    },

    clearBoundClientCache() {
      localStorage.removeItem('boundClientId');
      this.boundClientId = '';
      this.ipInputForm.ip = '';
      console.log('IP缓存已清除');
      this.isWebsocketConnected = false

    },
    
    // 处理客户端列表更新
    handleClientListUpdate(clients) {
      console.log('更新客户端列表:', clients);
      this.clientList = clients;
      this.isClientListLoaded = true;
      
      // 只在非定期重新认证时显示成功消息并发送启动ASR指令
      if (this.boundClientId && !this.isPeriodicAuth) {
        this.$message({
          message: '客户端连接成功',
          type: 'success',
          duration: 2000,
        });

        // 发送启动ASR指令
        try {
          if (this.micWebsocket && this.micWebsocket.readyState === WebSocket.OPEN) {
            this.micWebsocket.send(JSON.stringify({
              type: 'to-client-by-ip',
              ip: this.boundClientId,
              data: {
                action: 'start-asr',
                params: { key: '123456' }
              }
            }));
            console.log(`已发送启动ASR指令到客户端 IP ${this.boundClientId}`);
          } else {
            console.warn('WebSocket未就绪，无法发送启动ASR指令');
          }
        } catch (e) {
          console.error('发送启动ASR指令失败', e);
        }
      }
      
      // 重置定期认证标志
      this.isPeriodicAuth = false;
    },

  },
  mounted() {
    // 移除原有的 this.startTimer();
    // 计时器将在 getInterviewInfo 成功后启动
    this.$nextTick(() => {
      const toolbar = this.$refs.toolbarRef;
      if (toolbar && toolbar.scrollHeight > toolbar.clientHeight) {
        toolbar.scrollTop = toolbar.scrollHeight;
      }
    });

    // 设置页面可见性监听器
    this.setupVisibilityListener();

    // 注册全局快捷键
    this.globalShortcutListener = (event) => {
      console.log('快捷键检测:', {
        altKey: event.altKey,
        key: event.key,
        code: event.code,
        metaKey: event.metaKey,
        ctrlKey: event.ctrlKey,
        type: event.type
      });
      
      // 检测Mac系统的Option键（altKey在Mac中对应Option键）
      const isMacOption = event.altKey && !event.metaKey && !event.ctrlKey;
      const key = event.key.toUpperCase();
      const code = event.code;
      
      // Mac系统特殊处理：Option键会改变字符输入
      // Option+P -> π, Option+O -> ø, Option+I -> ˆ
      const macOptionKeyMap = {
        'π': 'P',  // Option+P
        'ø': 'O',  // Option+O  
        'ˆ': 'I'   // Option+I
      };
      
      // 获取实际的按键
      const actualKey = macOptionKeyMap[key] || key;
      
      // captureShortcut: Mac: option+I, Windows: Alt+I
      if (isMacOption && (actualKey === 'I' || code === 'KeyI')) {
        event.preventDefault();
        event.stopPropagation();
        console.log('触发截图快捷键');
        this.handleScreenshotAnswer();
        return;
      }
      // fastAnswerShortcut: Mac: option+P, Windows: Alt+P
      if (isMacOption && (actualKey === 'P' || code === 'KeyP')) {
        event.preventDefault();
        event.stopPropagation();
        console.log('触发快答快捷键');
        this.quickAnswerAction();
        return;
      }
      // deepAnswerShortcut: Mac: option+O, Windows: Alt+O
      if (isMacOption && (actualKey === 'O' || code === 'KeyO')) {
        event.preventDefault();
        event.stopPropagation();
        console.log('触发深度回答快捷键');
        this.deepAnswerAction();
        return;
      }
    };
    
    // 使用多种方式注册事件监听器，确保Mac系统兼容性
    window.addEventListener('keydown', this.globalShortcutListener, true);
    document.addEventListener('keydown', this.globalShortcutListener, true);
    
    // 为Mac系统添加额外的keyup事件监听（某些情况下keydown可能被拦截）
    this.globalShortcutListenerKeyup = (event) => {
      const isMacOption = event.altKey && !event.metaKey && !event.ctrlKey;
      const key = event.key.toUpperCase();
      const code = event.code;
      
      // Mac系统特殊处理：Option键会改变字符输入
      const macOptionKeyMap = {
        'π': 'P',  // Option+P
        'ø': 'O',  // Option+O  
        'ˆ': 'I'   // Option+I
      };
      
      const actualKey = macOptionKeyMap[key] || key;
      
      if (isMacOption && (actualKey === 'I' || actualKey === 'P' || actualKey === 'O' || 
                         code === 'KeyI' || code === 'KeyP' || code === 'KeyO')) {
        event.preventDefault();
        event.stopPropagation();
        console.log('通过keyup事件触发快捷键:', actualKey);
        
        if (actualKey === 'I' || code === 'KeyI') this.handleScreenshotAnswer();
        else if (actualKey === 'P' || code === 'KeyP') this.quickAnswerAction();
        else if (actualKey === 'O' || code === 'KeyO') this.deepAnswerAction();
      }
    };
    
    // 只在Mac系统上添加keyup监听器
    if (isMacOS()) {
      window.addEventListener('keyup', this.globalShortcutListenerKeyup, true);
      document.addEventListener('keyup', this.globalShortcutListenerKeyup, true);
    }

    // 添加窗口大小变化监听器
    this.resizeHandler = () => {
      // 触发响应式更新
      this.$forceUpdate();
    };
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeUnmount() {
    // 清理全局快捷键监听器
    if (this.globalShortcutListener) {
      window.removeEventListener('keydown', this.globalShortcutListener, true);
      document.removeEventListener('keydown', this.globalShortcutListener, true);
      this.globalShortcutListener = null;
    }
    
    // 清理Mac系统的keyup监听器
    if (this.globalShortcutListenerKeyup) {
      window.removeEventListener('keyup', this.globalShortcutListenerKeyup, true);
      document.removeEventListener('keyup', this.globalShortcutListenerKeyup, true);
      this.globalShortcutListenerKeyup = null;
    }
    
    // 清理用户自定义快捷键监听器
    if (this.shortcutListener) {
      window.removeEventListener('keydown', this.shortcutListener, true);
      this.shortcutListener = null;
    }
    // 清理页面可见性监听器
    this.removeVisibilityListener();
    // 清理resize监听器
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
    // 清理心跳定时器
    this.stopHeartbeat();
    // 清理WebSocket连接
    if (this.micWebsocket) {
      try {
        if (this.micWebsocket.readyState === WebSocket.OPEN) {
          this.micWebsocket.send(JSON.stringify({
            type: 'to-client-by-ip',
            ip: this.boundClientId,
            data: { action: 'stop-asr' }
          }));
          console.log(`组件卸载：断开前已发送停止ASR指令到 ${this.boundClientId}`);
        }
      } catch (e) {
        console.error('组件卸载：发送停止ASR指令失败', e);
      }
      this.micWebsocket.close();
      this.micWebsocket = null;
    }
    // 清理重连定时器
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    // 清理拖拽事件监听器
    document.removeEventListener('mousemove', this.handleResize);
    document.removeEventListener('mouseup', this.stopResize);
    // 清理音量定时器
    if (this.micVolumeTimer) {
      clearTimeout(this.micVolumeTimer);
      this.micVolumeTimer = null;
    }
    if (this.speakerVolumeTimer) {
      clearTimeout(this.speakerVolumeTimer);
      this.speakerVolumeTimer = null;
    }
  },
  watch: {
    quickAnswerContent() {
      if (this.isDarkMode) {
        this.$nextTick(() => this.applyDarkTableFix());
      }
    },
    deepThinkReason() {
      if (this.isDarkMode) {
        this.$nextTick(() => this.applyDarkTableFix());
      }
    },
    deepThinkAnswer() {
      if (this.isDarkMode) {
        this.$nextTick(() => this.applyDarkTableFix());
      }
    },
    questionAnalysis() {
      this.saveAnswerCache();
    },
    parsedMarkdownAnswer(newVal, oldVal) {
      if (oldVal === '' && newVal && this.parsedMarkdownReason) {
        this.isThinkingCollapsed = true;
      }
    },
    isWebsocketConnected(newVal) {
      if (newVal) {
        // 连接时启动计时
        if (this.websocketTimer) clearInterval(this.websocketTimer);
        this.websocketTimer = setInterval(() => {
          this.websocketSeconds++;
          // 保存到store缓存
          const interviewId = this.$route.query.interviewId;
          if (interviewId && this.store.setWebsocketTimeByInterviewId) {
            this.store.setWebsocketTimeByInterviewId(interviewId, this.websocketSeconds);
          }
          // 每累计1分钟调用后端接口
          if (this.websocketSeconds > 0 && this.websocketSeconds % 60 === 0) {
            const id = this.$route.query.interviewId;
            if (id && this.isWebsocketConnected) {
              this.$nextTick(() => {
                // 再次检查连接状态，防止异步执行时连接已断开
                if (this.isWebsocketConnected) {
                  this.recordWebsocketUsage(id);
                }
              });
            }
          }
        }, 1000);
      } else {
        // 断开时清除计时
        if (this.websocketTimer) {
          clearInterval(this.websocketTimer);
          this.websocketTimer = null;
        }
      }
    },
  },
};
</script>

<style>
/* 响应式布局 */
.interview-container {
  width: 100%;
  height: 100vh;
  font-size: 16px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.interview-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8f9fb;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.interview-header {
  padding: 4px 16px;
  height: 32px;
  border-bottom: 1px solid #e5e6eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: #fff;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: visible;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.time-block {
  display: flex;
  align-items: center;
  background: #f0f5ff;
  border-radius: 16px;
  padding: 2px 14px 2px 10px;
  font-size: 13px;
  color: #3056d3;
  font-weight: 500;
  gap: 6px;
}

.label {
  font-size: 13px;
  color: #3056d3;
  margin-right: 2px;
  font-weight: 500;
}

.timer {
  font-size: 13px;
  color: #3056d3;
  font-weight: 600;
  letter-spacing: 1px;
}

.stats-block {
  display: flex;
  align-items: center;
  background: #f7f8fa;
  border-radius: 16px;
  padding: 2px 16px;
  font-size: 13px;
  color: #4e5969;
  font-weight: 400;
  gap: 10px;
}

.stats-item {
  font-size: 13px;
  color: #4e5969;
  font-weight: 400;
}

.stats-item b {
  font-weight: 600;
  color: #3056d3;
}

.stats-divider {
  color: #e5e6eb;
  font-size: 15px;
  margin: 0 8px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  justify-content: flex-end;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4e5969;
}

.toggle-switch {
  width: 36px;
  height: 20px;
  background: #e5e6eb;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s;
}

.toggle-switch.is-checked {
  background: #1890ff;
}

.toggle-switch-handle {
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: all 0.2s;
}

.toggle-switch.is-checked .toggle-switch-handle {
  left: 18px;
}

.icon-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #4e5969;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 24px;
  min-height: 24px;
}

.settings-btn {
  padding: 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #4e5969;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  gap: 4px;
  align-items: center;
}

.settings-btn:hover {
  background: #f2f3f5;
}

.icon-btn:hover {
  background: #f2f3f5;
}

.icon-btn svg {
  width: 16px;
  height: 16px;
  display: block;
}

.client-btn {
  display: inline-flex !important;
  visibility: visible !important;
  opacity: 1 !important;
  padding: 4px 8px !important;
  border: 1px solid #e5e6eb !important;
  border-radius: 4px !important;
  background: transparent !important;
  z-index: 10 !important;
  color: #4e5969 !important;
  font-size: 12px !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
  gap: 4px !important;
  align-items: center !important;
}

.client-btn:hover {
  background: #f2f3f5 !important;
  border-color: #c0c4cc !important;
}

.snapshot-btn {
  padding: 4px 8px;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  background: transparent;
  color: #4e5969;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  gap: 4px;
  align-items: center;
}

.snapshot-btn:hover {
  background: #f2f3f5;
  border-color: #c0c4cc;
}

.end-btn {
  padding: 4px 12px;
  border: none;
  border-radius: 4px;
  background: #ff4d4f;
  color: white;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.end-btn:hover {
  background: #ff7875;
}

.interview-content {
  flex: 1;
  display: flex;
  min-height: 0;
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0;
  padding-right: 80px;
  /* 右侧为工具栏预留空间，避免内容被遮挡 */
}

.chat-sidebar {
  width: 18%;
  border-right: 1px solid #e5e6eb;
  display: flex;
  flex-direction: column;
  background: #00000000;
  flex-shrink: 0;
  z-index: 1;
  height: 100%;
  margin-right: 0px;
  margin-top: 0;
  padding-top: 0;
  box-sizing: border-box;
  padding-right: 0px;
}

.tab-title {
  padding: 2px 8px;
  font-size: 12px;
  font-weight: normal;
  /* background: #f0f2f5; */
  border-radius: 2px;
  margin: 0px 4px 0 4px;
  line-height: 1.5;
  height: 22px;
  display: flex;
  align-items: center;
}



.chat-messages {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  height: 100%;
  padding: 2px 4px;
  overflow-y: auto;
  background: #fff;
  border-radius: 4px;
  margin: 0 4px 4px 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  border: 1px solid #e5e6eb;
}

/* 当没有对话记录时隐藏滚动条 */
.chat-messages.no-scroll {
  overflow-y: hidden;
}

.message {
  white-space: normal;
  overflow: visible;
  padding: 8px 4px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.message-sender {
  font-size: 11px;
  color: #888;
}

.message-text {
  font-size: 12px;
  line-height: 1.4;
  word-wrap: break-word;
  word-break: break-word;
  white-space: pre-wrap;
  margin: 4px 0;
}

.message-time {
  font-size: 10px;
  color: #bbb;
}

/* 音频监控区域样式 */
.audio-monitor {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 4px;
  margin: 0 4px 4px 4px;
  background: #f8f9fb;
  border-radius: 4px;
  border: 1px solid #e5e6eb;
}

.audio-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.audio-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #666;
  flex-shrink: 0;
}

.volume-bar {
  flex: 1;
  height: 8px;
  background: #e5e6eb;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.volume-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.1s ease-out;
}

.mic-volume {
  background: linear-gradient(90deg, #52c41a, #73d13d);
}

.speaker-volume {
  background: linear-gradient(90deg, #1890ff, #40a9ff);
}

.quick-answer-btn {
  padding: 2px 4px;
  font-size: 11px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.answer-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
  background: #f8f9fb;
  margin-left: 0;
  padding: 0;
  margin-top: 0;
  width: 82%;
  max-width: 82%;
  overflow: hidden;
  box-sizing: border-box;
  height: 100%;
}

.question-panel {
  padding: 0 0 8px 0;
  border-bottom: 1px solid #e5e6eb;
  background: transparent;
  flex-shrink: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
}

.panel-title {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
  padding: 2px 8px;
  /* background: #f0f2f5; */
  border-radius: 2px;
  line-height: 1.5;
  height: 22px;
  display: flex;
  align-items: center;
  margin-left: 0;
  position: relative;
  z-index: 2;
}

.question-edit-wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.analysis-input.editable.full-width {
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  max-width: 100%;
  border: 1px solid #e5e6eb;
  background: #fff;
  border-radius: 0;
  box-shadow: none;
  outline: none;
  transition: border-color 0.2s;
  color: #b8b2b2;
  font-size: 14px;
}

.analysis-input.editable.full-width::placeholder {
  color: #b8b2b2;
  font-size: 14px;
}

.analysis-input.editable.full-width:focus {
  border-color: #409eff;
}

.reanswer-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  padding: 1px 8px;
  font-size: 8px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s;
}

.reanswer-btn:hover {
  background: #40a9ff;
}

/* 按钮容器样式 */
.button-container {
  position: absolute;
  top: 8px;
  right: 12px;
  display: flex;
  gap: 8px;
  z-index: 2;
}

/* 竖着按钮样式 */
.reanswer-btn.vertical-btn {
  position: static;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 40px;
  padding: 4px 2px;
  font-size: 10px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.reanswer-btn.vertical-btn:hover {
  background: #40a9ff;
}

.reanswer-btn.vertical-btn .btn-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  line-height: 1.2;
}

.answer-panels {
  flex: 1;
  display: flex;
  padding: 0;
  margin: 0;
  gap: 0;
  background: transparent;
  min-height: 0;
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.tab-panel {
  display: flex;
  flex-direction: column;
  background: transparent;
  border: none;
  min-height: 0;
  position: relative;
  border-radius: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  height: 100%;
}

.panel-header {
  padding: 2px 0;
  background: transparent;
  border-bottom: none;
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
  z-index: 1;
  height: 22px;
  display: flex;
  align-items: center;
  border-radius: 6px 6px 0 0;
}


.answer-input {
  flex: 1;
  width: 100%;
  min-height: 0;
  padding: 0;
  border-left: none;
  border-right: none;
  border-top: 1px solid #e5e6eb;
  border-bottom: 1px solid #e5e6eb;
  border-radius: 0;
  font-size: 12px;
  line-height: 1.5;
  resize: none;
  background: #fff;
  overflow: hidden;
  margin: 0;
  box-shadow: none;
  box-sizing: border-box;
  height: 100%;
}

.divider {
  width: 16px;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  z-index: 5;
  background-color: transparent;
}

.divider-line {
  width: 1px;
  height: 100%;
  cursor: col-resize;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  background-color: #e5e6eb;
  z-index: 1;
}

.switch-btn {
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  background: #1890ff;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: none;
  border: 1px solid #fff;
  padding: 0;
  z-index: 2;
}

.switch-btn:hover {
  background: #40a9ff;
  transform: translate(-50%, -50%) scale(1.1);
  box-shadow: none;
}

.submit-btn {
  padding: 4px 12px;
  border: none;
  border-radius: 4px;
  background: #1890ff;
  color: white;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn:hover {
  background: #40a9ff;
}

.big-btn {
  font-size: 16px;
  font-weight: bold;
  padding: 8px 20px;
}

.inner-btn {
  position: absolute;
  right: 16px;
  bottom: 12px;
  z-index: 2;
  font-size: 16px;
  font-weight: bold;
  padding: 8px 20px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.inner-btn:hover {
  background: #40a9ff;
}

.answer-box-big {
  min-height: 120px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 0 !important;
  overflow-y: auto;
}

.content-area {
  flex: 1;
  overflow-y: auto;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* 快答区域表格样式 */
.content-area table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
  font-size: 13px;
  max-width: 100%;
  table-layout: auto;
}

.content-area table thead {
  background-color: #f5f7fa;
}

.content-area table th {
  padding: 8px 12px;
  text-align: left;
  font-weight: 600;
  border: 1px solid #e5e6eb;
  background-color: #f5f7fa;
}

.content-area table td {
  padding: 8px 12px;
  border: 1px solid #e5e6eb;
}

.content-area table tr:nth-child(even) {
  background-color: #fafbfc;
}

.content-area table tr:hover {
  background-color: #f0f2f5;
}

.empty-conversation {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
  color: #b8b2b2;
}

/* 确保el-empty组件的description文字颜色 */
.empty-conversation .el-empty__description {
  color: #b8b2b2 !important;
}

.empty-conversation .el-empty p {
  color: #b8b2b2 !important;
}



/* 思考过程区域样式 */
.thinking-section {
  margin-bottom: 1px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  background: #fafbfc;
  overflow: hidden;
}

.thinking-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f0f2f5;
  border-bottom: 1px solid #e5e6eb;
  cursor: pointer;
  transition: background-color 0.2s;
}

.thinking-header:hover {
  background: #e6f7ff;
}

.thinking-title {
  font-size: 13px;
  font-weight: 500;
  color: #1890ff;
}

.toggle-icon {
  color: #666;
  transition: transform 0.2s;
}

.toggle-icon.expanded {
  transform: rotate(180deg);
}

.thinking-content {
  padding: 12px;
  max-height: 300px;
  overflow-y: auto;
  transition: max-height 0.3s ease;
}

.thinking-content.collapsed {
  max-height: 0;
  padding: 0 12px;
  overflow: hidden;
}

/* 答案区域样式 */
.answer-section {
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.answer-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f6ffed;
  border-bottom: 1px solid #e5e6eb;
}

.answer-title {
  font-size: 13px;
  font-weight: 500;
  color: #1890ff;
}

.answer-content {
  padding: 12px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  margin-bottom: 0 !important;
}

/* IP配置弹窗样式 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.el-form-item {
  margin-bottom: 20px;
}

.thinking-status {
  color: #1890ff;
  font-size: 13px;
  margin-top: 0px;
}

/* 右侧工具栏样式 */
.toolbar {
  position: fixed;
  right: 8px;
  top: 24px;
  /* 与answer-input顶部边框对齐：22px panel-header */
  bottom: 26px;
  /* 与question-panel下边框对齐：8px question-panel padding + 8px 下边距 */
  width: 56px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e6eb;
  display: flex;
  flex-direction: column;
  padding: 8px 4px;
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 50px);
  /* 24px top + 16px bottom */
  /* 防止滚动回弹 */
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  /* 确保底部内容可见 */
  scroll-padding-bottom: 8px;
}

.toolbar-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
  min-height: fit-content;
  flex-shrink: 0;
}

.toolbar-section:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
}

.toolbar-section:last-child {
  padding-bottom: 12px;
  /* 确保最后一个section底部有足够空间 */
}

.toolbar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 2px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  color: #4e5969;
  position: relative;
  min-height: 50px;
}

.toolbar-item:hover {
  background: #f0f5ff;
  color: #1890ff;
}

.toolbar-item .toggle-switch {
  width: 20px;
  height: 12px;
  background: #e5e6eb;
  border-radius: 6px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 2px;
}

.toolbar-item .toggle-switch.is-checked {
  background: #1890ff;
}

.toolbar-item .toggle-switch-handle {
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: all 0.2s;
}

.toolbar-item .toggle-switch.is-checked .toggle-switch-handle {
  left: 10px;
}

.tool-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: #f7f8fa;
  transition: all 0.2s;
}

.toolbar-item:hover .tool-icon {
  background: #e6f7ff;
}

.toolbar-item .end-icon {
  background: #fff2f0;
  color: #ff4d4f;
}

.toolbar-item:hover .end-icon {
  background: #ffccc7;
  color: #ff7875;
}

.tool-label {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  line-height: 1.1;
  max-width: 48px;
  word-break: break-word;
}

/* 快答/深度区域无内容时的提示 */
.empty-answer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #b8b2b2;
  font-size: 14px;
  height: 100%;
  min-height: 80px;
  text-align: center;
  padding: 24px 0;
  pointer-events: none;
}

/* 思考中...紧贴思考过程 */
.thinking-status-inline {
  color: #1890ff;
  font-size: 13px;
  margin-left: 8px;
  font-weight: normal;
  display: inline;
}

/***** 深色模式样式 *****/
:global(body.dark-mode) {
  background: #181818 !important;
  color: #fff !important;
}

:global(body.dark-mode) .interview-page,
:global(body.dark-mode) .interview-header,
:global(body.dark-mode) .chat-sidebar,
:global(body.dark-mode) .answer-area,
:global(body.dark-mode) .answer-input,
:global(body.dark-mode) .panel-header,
:global(body.dark-mode) .toolbar,
:global(body.dark-mode) .toolbar-item,
:global(body.dark-mode) .question-panel,
:global(body.dark-mode) .tab-panel,
:global(body.dark-mode) .content-area,
:global(body.dark-mode) .thinking-section,
:global(body.dark-mode) .answer-section {
  background: #6a707b !important;
  color: #fff !important;
  border-color: #333 !important;
}

:global(body.dark-mode) .message,
:global(body.dark-mode) .message-sender,
:global(body.dark-mode) .message-text,
:global(body.dark-mode) .message-time,
:global(body.dark-mode) .tab-title,
:global(body.dark-mode) .panel-title,
:global(body.dark-mode) .tool-label {
  color: #fff !important;
}

:global(body.dark-mode) .toolbar-item:hover {
  background: #333 !important;
  color: #fff !important;
}

:global(body.dark-mode) .tool-icon {
  background: #333 !important;
}

:global(body.dark-mode) .toolbar-item .end-icon {
  background: #3a2323 !important;
  color: #ff4d4f !important;
}

:global(body.dark-mode) .toolbar-item:hover .end-icon {
  background: #5a2323 !important;
  color: #ff7875 !important;
}

:global(body.dark-mode) .answer-area .area-bar-vertical,
:global(body.dark-mode) .area-bar-vertical {
  background: #6a707b !important;
  border-left-color: #333 !important;
  border-right-color: #333 !important;
}

:global(body.dark-mode) .thinking-header {
  background: #6a707b !important;
  border-bottom-color: #333 !important;
}

:global(body.dark-mode) .answer-header {
  background: #6a707b !important;
  border-bottom-color: #333 !important;
}

:global(body.dark-mode) .reanswer-btn,
:global(body.dark-mode) .reanswer-btn.vertical-btn,
:global(body.dark-mode) .button-container .reanswer-btn,
:global(body.dark-mode) .button-container .reanswer-btn.vertical-btn {
  background: #1890ff !important;
  color: #fff !important;
  border-color: #1890ff !important;
}

:global(body.dark-mode) .reanswer-btn:hover,
:global(body.dark-mode) .reanswer-btn.vertical-btn:hover,
:global(body.dark-mode) .button-container .reanswer-btn:hover,
:global(body.dark-mode) .button-container .reanswer-btn.vertical-btn:hover {
  background: #40a9ff !important;
  border-color: #40a9ff !important;
}

/* 强制覆盖深色模式下的按钮样式 */
:global(body.dark-mode) button.reanswer-btn,
:global(body.dark-mode) button.reanswer-btn.vertical-btn {
  background: #1890ff !important;
  color: #fff !important;
  border-color: #1890ff !important;
}

:global(body.dark-mode) button.reanswer-btn:hover,
:global(body.dark-mode) button.reanswer-btn.vertical-btn:hover {
  background: #40a9ff !important;
  border-color: #40a9ff !important;
}

/***** END 深色模式样式 *****/

.toggle-deep-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 6px;
  margin-left: 8px;
  outline: none;
  display: flex;
  align-items: center;
  transition: background 0.2s;
}

.toggle-deep-btn:hover {
  background: #f0f5ff;
}

.toggle-deep-btn-text {
  background: none;
  border: none;
  color: #1890ff;
  font-size: 13px;
  cursor: pointer;
  padding: 2px 10px;
  margin-left: 8px;
  outline: none;
  transition: color 0.2s;
}

.toggle-deep-btn-text:hover {
  color: #1890ff;
  background: #f0f5ff;
}

.area-bar-vertical {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  text-align: center;
  font-size: 16px;
  color: #1890ff;
  font-weight: bold;
  border-left: 1px solid #e5e6eb;
  border-right: 1px solid #e5e6eb;
  background: #ffffff;
}

/* 平板设备适配 - 优化工具栏滚动和底部显示 */
@media (min-width: 769px) and (max-width: 1024px) {
  .toolbar {
    /* 确保工具栏在平板上的滚动行为正常 */
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
    scroll-padding-bottom: 12px;
    /* 增加底部滚动内边距，确保底部按钮可见 */
  }

  .toolbar-section:last-child {
    padding-bottom: 16px;
    /* 平板设备上增加底部空间 */
  }
}

/* 手机屏幕适配 - 字体变小三分之一 */
@media (max-width: 768px) {
  .tab-title {
    font-size: 8px !important;
    padding: 1px 3px !important;
    height: 10px !important;
  }
}

/* 手机屏幕适配 - el-empty组件图标和字体变小三分之一 */
@media (max-width: 768px) {
  .empty-conversation .el-empty__image {
    width: 53px !important;
    height: 53px !important;
  }

  .empty-conversation .el-empty__description {
    font-size: 12px !important;
    margin-top: 8px !important;
  }

  /* 更具体的选择器 */
  .empty-conversation .el-empty img {
    width: 53px !important;
    height: 53px !important;
  }

  .empty-conversation .el-empty p {
    font-size: 12px !important;
    margin-top: 8px !important;
  }

  /* Element Plus 可能的类名 */
  .empty-conversation .el-empty .el-empty__image {
    width: 53px !important;
    height: 53px !important;
  }

  .empty-conversation .el-empty .el-empty__description {
    font-size: 12px !important;
    margin-top: 8px !important;
  }

  /* 直接针对SVG图标 */
  .empty-conversation .el-empty svg {
    width: 53px !important;
    height: 53px !important;
  }

  /* 针对所有可能的文本元素 */
  .empty-conversation .el-empty .el-empty__description,
  .empty-conversation .el-empty p,
  .empty-conversation .el-empty span {
    font-size: 12px !important;
  }
}

/* 手机屏幕适配 - 空状态提示文字变小三分之一 */
@media (max-width: 768px) {
  .empty-answer {
    font-size: 9px !important;
    /* 14px * 2/3 ≈ 9px */
    padding: 16px 0 !important;
    /* 24px * 2/3 ≈ 16px */
    min-height: 53px !important;
    /* 80px * 2/3 ≈ 53px */
  }

  /* 思考过程区域字体变小三分之一 */
  .thinking-title {
    font-size: 9px !important;
    /* 13px * 2/3 ≈ 9px */
  }

  .thinking-header {
    padding: 5px 8px !important;
    /* 8px 12px * 2/3 ≈ 5px 8px */
  }

  .thinking-content {
    padding: 8px !important;
    /* 12px * 2/3 ≈ 8px */
  }

  /* 答案区域字体变小三分之一 */
  .answer-title {
    font-size: 9px !important;
    /* 13px * 2/3 ≈ 9px */
  }

  .answer-header {
    padding: 5px 8px !important;
    /* 8px 12px * 2/3 ≈ 5px 8px */
  }

  .answer-content {
    padding: 8px !important;
    /* 12px * 2/3 ≈ 8px */
  }

  /* 思考中状态字体变小三分之一 */
  .thinking-status-inline {
    font-size: 9px !important;
    /* 13px * 2/3 ≈ 9px */
    margin-left: 5px !important;
    /* 8px * 2/3 ≈ 5px */
  }

  /* 切换图标变小三分之一 */
  .toggle-icon {
    width: 11px !important;
    /* 16px * 2/3 ≈ 11px */
    height: 11px !important;
  }

  /* 切换图标变小三分之一 */
  .toggle-icon {
    width: 11px !important;
    /* 16px * 2/3 ≈ 11px */
    height: 11px !important;
  }

  /* v-html动态内容字体变小三分之一 */
  .thinking-content div,
  .thinking-content p,
  .thinking-content span,
  .thinking-content h1,
  .thinking-content h2,
  .thinking-content h3,
  .thinking-content h4,
  .thinking-content h5,
  .thinking-content h6,
  .thinking-content li,
  .thinking-content td,
  .thinking-content th {
    font-size: 9px !important;
    /* 默认字体大小约14px，变小三分之一约为9px */
    line-height: 1.4 !important;
  }

  .answer-content div,
  .answer-content p,
  .answer-content span,
  .answer-content h1,
  .answer-content h2,
  .answer-content h3,
  .answer-content h4,
  .answer-content h5,
  .answer-content h6,
  .answer-content li,
  .answer-content td,
  .answer-content th {
    font-size: 9px !important;
    /* 默认字体大小约14px，变小三分之一约为9px */
    line-height: 1.4 !important;
  }

  /* 代码块字体变小三分之一 */
  .thinking-content pre,
  .thinking-content code,
  .answer-content pre,
  .answer-content code {
    font-size: 8px !important;
    /* 代码字体稍小一些 */
    line-height: 1.3 !important;
  }

  /* 表格字体变小三分之一 */
  .thinking-content table,
  .answer-content table {
    font-size: 8px !important;
  }

  .thinking-content table td,
  .thinking-content table th,
  .answer-content table td,
  .answer-content table th {
    padding: 2px 4px !important;
    /* 减小表格内边距 */
  }

  /* 快答区域v-html动态内容字体变小三分之一 */
  .answer-input .content-area div,
  .answer-input .content-area p,
  .answer-input .content-area span,
  .answer-input .content-area h1,
  .answer-input .content-area h2,
  .answer-input .content-area h3,
  .answer-input .content-area h4,
  .answer-input .content-area h5,
  .answer-input .content-area h6,
  .answer-input .content-area li,
  .answer-input .content-area td,
  .answer-input .content-area th {
    font-size: 9px !important;
    line-height: 1.4 !important;
  }

  /* 快答区域代码块字体变小三分之一 */
  .answer-input .content-area pre,
  .answer-input .content-area code {
    font-size: 8px !important;
    line-height: 1.3 !important;
  }

  /* 快答区域表格字体变小三分之一 */
  .answer-input .content-area table {
    font-size: 8px !important;
  }

  .answer-input .content-area table td,
  .answer-input .content-area table th {
    padding: 2px 4px !important;
  }

  /* 问题修正区域在手机端变小三分之一 */
  .question-edit-wrapper {
    font-size: 9px !important;
  }

  .analysis-input.editable.full-width {
    font-size: 9px !important;
    padding: 4px 6px !important;
    min-height: 20px !important;
  }

  .reanswer-btn {
    font-size: 6px !important;
    padding: 1px 5px !important;
  }

  .reanswer-btn.vertical-btn {
    width: 20px !important;
    height: 25px !important;
    font-size: 8px !important;
    padding: 2px 1px !important;
  }

  .reanswer-btn svg {
    width: 13px !important;
    height: 13px !important;
  }

  /* 工具栏区域在手机端变小三分之一 */
  .toolbar {
    top: 17px;
    /* 与answer-input顶部边框对齐：22px panel-header */
    bottom: 18px;
    /* 与question-panel下边框对齐：8px question-panel padding + 8px 下边距 */
    height: calc(100vh - 36px);
    /* 24px top + 16px bottom */
    width: 46px !important;
    font-size: 9px !important;
    right: 0px !important;
    min-height: 32px !important;
    /* 原48px缩小为32px，如有设置 */
    padding: 4px 0 !important;
    /* 防止滚动回弹，确保底部按钮可见 */
    overscroll-behavior: none !important;
    -webkit-overflow-scrolling: touch !important;
    scroll-padding-bottom: 8px !important;
  }

  .toolbar-section:last-child {
    padding-bottom: 12px !important;
    /* 手机端也确保最后一个section底部有足够空间 */
  }

  .toolbar-item {
    font-size: 9px !important;
    padding: 2px 4px !important;
    min-width: 32px !important;
    /* 原48px缩小为32px，如有设置 */
  }

  .tool-label {
    font-size: 8px !important;
    line-height: 1.2 !important;
  }

  .tool-icon,
  .toolbar-item .tool-icon {
    width: 13px !important;
    /* 原20px缩小为13px */
    height: 13px !important;
    min-width: 13px !important;
    min-height: 13px !important;
  }

  .toolbar-item svg {
    width: 13px !important;
    height: 13px !important;
  }

  /* 标题父容器在手机端高度和内边距变小 */
  .panel-header {
    height: 10px !important;
    /* 原22px，缩小为14px */
    padding: 1px 0 !important;
    /* 原2px 0，缩小为1px 0 */
  }

  .interview-content {
    flex: 1;
    display: flex;
    min-height: 0;
    position: relative;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0;
    padding-right: 50px;
    /* 右侧为工具栏预留空间，避免内容被遮挡 */
  }

  /* 沟通记录消息区域在手机端缩小三分之一 */
  .message-header {
    margin-bottom: 2px !important;
    /* 原4px缩小为2px */
  }

  .message-sender,
  .message-text,
  .message-time {
    font-size: 9px !important;
    /* 原14px缩小为9px */
    line-height: 1.4 !important;
  }

  .quick-answer-btn {
    font-size: 8px !important;
    /* 原12px缩小为8px */
    padding: 2px 6px !important;
    /* 原padding缩小 */
    min-height: 18px !important;
    /* 原27px缩小为18px，如有设置 */
    min-width: 18px !important;
    /* 原54px缩小为36px，如有设置 */
  }
}

::global(body.dark-mode) button.reanswer-btn:hover,
::global(body.dark-mode) button.reanswer-btn.vertical-btn:hover {
  background: #40a9ff !important;
  border-color: #40a9ff !important;
}

/***** 深色模式下 Markdown 表格可读性增强（快答/深度区域） *****/
::global(body.dark-mode) .content-area table {
  background: #2b2b2b !important;
  color: #e6e6e6 !important;
  border-collapse: collapse !important;
  border-color: #444 !important;
}

::global(body.dark-mode) .content-area th,
::global(body.dark-mode) .content-area td {
  background: transparent !important;
  color: #e6e6e6 !important;
  border: 1px solid #444 !important;
}

::global(body.dark-mode) .content-area thead th {
  background: #3a3f44 !important;
  color: #ffffff !important;
}

::global(body.dark-mode) .content-area tbody tr:nth-child(odd) {
  background: #2e3237 !important;
}

::global(body.dark-mode) .content-area tbody tr:nth-child(even) {
  background: #2b2b2b !important;
}

/* 表格内链接与行内代码在深色下的对比度 */
::global(body.dark-mode) .content-area a {
  color: #91c9ff !important;
}

::global(body.dark-mode) .content-area code {
  background: #1f1f1f !important;
  color: #ffd580 !important;
  border-radius: 3px !important;
  padding: 0 3px !important;
}

/***** END 深色模式样式 *****/

/***** 深色模式下 Markdown 表格可读性增强（快答/深度区域） —— 扩展与强化 *****/
::global(body.dark-mode) .content-area table,
::global(body.dark-mode) .thinking-content table,
::global(body.dark-mode) .answer-content table {
  background: #000 !important;
  color: #fff !important;
  border-collapse: collapse !important;
  border-color: #444 !important;
}

/* 表头/行/单元格全部强制黑底白字，避免任何白底覆盖 */
::global(body.dark-mode) .content-area thead,
::global(body.dark-mode) .thinking-content thead,
::global(body.dark-mode) .answer-content thead,
::global(body.dark-mode) .content-area tbody,
::global(body.dark-mode) .thinking-content tbody,
::global(body.dark-mode) .answer-content tbody,
::global(body.dark-mode) .content-area tr,
::global(body.dark-mode) .thinking-content tr,
::global(body.dark-mode) .answer-content tr,
::global(body.dark-mode) .content-area th,
::global(body.dark-mode) .thinking-content th,
::global(body.dark-mode) .answer-content th,
::global(body.dark-mode) .content-area td,
::global(body.dark-mode) .thinking-content td,
::global(body.dark-mode) .answer-content td {
  background: #000 !important;
  color: #fff !important;
}

::global(body.dark-mode) .content-area th,
::global(body.dark-mode) .content-area td,
::global(body.dark-mode) .thinking-content th,
::global(body.dark-mode) .thinking-content td,
::global(body.dark-mode) .answer-content th,
::global(body.dark-mode) .answer-content td {
  border: 1px solid #444 !important;
}

/* 取消斑马纹，统一黑底 */
::global(body.dark-mode) .content-area tbody tr:nth-child(odd),
::global(body.dark-mode) .thinking-content tbody tr:nth-child(odd),
::global(body.dark-mode) .answer-content tbody tr:nth-child(odd),
::global(body.dark-mode) .content-area tbody tr:nth-child(even),
::global(body.dark-mode) .thinking-content tbody tr:nth-child(even),
::global(body.dark-mode) .answer-content tbody tr:nth-child(even) {
  background: #000 !important;
}

/* 表格内文本元素继承颜色，避免被默认样式洗白 */
::global(body.dark-mode) .content-area table p,
::global(body.dark-mode) .content-area table li,
::global(body.dark-mode) .content-area table span,
::global(body.dark-mode) .thinking-content table p,
::global(body.dark-mode) .thinking-content table li,
::global(body.dark-mode) .thinking-content table span,
::global(body.dark-mode) .answer-content table p,
::global(body.dark-mode) .answer-content table li,
::global(body.dark-mode) .answer-content table span {
  color: inherit !important;
}

/* 链接与行内代码对比度（在黑底上更清晰） */
::global(body.dark-mode) .content-area a,
::global(body.dark-mode) .thinking-content a,
::global(body.dark-mode) .answer-content a {
  color: #8ecaff !important;
}

::global(body.dark-mode) .content-area code,
::global(body.dark-mode) .thinking-content code,
::global(body.dark-mode) .answer-content code {
  background: #111 !important;
  color: #ffd580 !important;
  border-radius: 3px !important;
  padding: 0 3px !important;
}

/* 深色模式 - 最高优先级强制去除斑马纹并统一黑底白字 */
::global(body.dark-mode) .content-area table > thead > tr,
::global(body.dark-mode) .content-area table > thead > tr > th,
::global(body.dark-mode) .content-area table > tbody > tr,
::global(body.dark-mode) .content-area table > tbody > tr > td,
::global(body.dark-mode) .thinking-content table > thead > tr,
::global(body.dark-mode) .thinking-content table > thead > tr > th,
::global(body.dark-mode) .thinking-content table > tbody > tr,
::global(body.dark-mode) .thinking-content table > tbody > tr > td,
::global(body.dark-mode) .answer-content table > thead > tr,
::global(body.dark-mode) .answer-content table > thead > tr > th,
::global(body.dark-mode) .answer-content table > tbody > tr,
::global(body.dark-mode) .answer-content table > tbody > tr > td {
  background: #000 !important;
  color: #fff !important;
}

/* 再次明确覆盖 nth-child 斑马纹（使用更具体的子代选择器） */
::global(body.dark-mode) .content-area table > tbody > tr:nth-child(odd),
::global(body.dark-mode) .content-area table > tbody > tr:nth-child(even),
::global(body.dark-mode) .thinking-content table > tbody > tr:nth-child(odd),
::global(body.dark-mode) .thinking-content table > tbody > tr:nth-child(even),
::global(body.dark-mode) .answer-content table > tbody > tr:nth-child(odd),
::global(body.dark-mode) .answer-content table > tbody > tr:nth-child(even) {
  background: #000 !important;
}

/* 兜底：任何放在单元格里的内联白底都覆盖 */
::global(body.dark-mode) .content-area table td *,
::global(body.dark-mode) .thinking-content table td *,
::global(body.dark-mode) .answer-content table td * {
  color: #fff !important;
}
</style>